import { useEffect } from 'react';
import { FunctionComponent } from 'react';
import Footer from '../shared/footer/footer';
import TopMenu from '../shared/top-menu/top-menu';
import DIV from '../shared/html-tags/div';
import { Helmet } from 'react-helmet-async';

export type Props = {};

const Privacy: FunctionComponent<Props> = (props) => {
  useEffect(() => {
    const usercentrics = document.querySelector('#usercentrics-root') as HTMLElement;
    if (usercentrics) {
      usercentrics.style.opacity = '0';
      console.log('removed');
    }
  }, []);
  useEffect(() => {
    return () => {
      const usercentrics = document.querySelector('#usercentrics-root') as HTMLElement;
      if (usercentrics) {
        usercentrics.style.opacity = '1';
        console.log('restored');
      }
    };
  }, []);

  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      <Helmet>
        <title>PS IMAGO PRO - Datenschutzerklärung</title>
        <meta
          name="description"
          content="Erfahre hier, wie wir deine Daten schützen und welche Rechte du hast. Lies unsere Datenschutzerklärung für PS IMAGO PRO."
        />
        <meta
          name="keywords"
          content="Datenschutzerklärung, PS IMAGO PRO, Datenschutz, 2x4 Solutions GmbH"
        />
        <link rel="canonical" href="https://predictivesolutions.2x4.de/de/privacy" />
      </Helmet>
      <div className="page privacy-page">
        <TopMenu selected="privacy"></TopMenu>

        <DIV language="de">
          <div className="page-content bg-top2">
            <div className="inner-content">
              <h1>Datenschutzerklärung</h1>
            </div>
          </div>
          <div className="page-content bg-1">
            <div className="inner-content">
              <h1>Datenschutz&shy;erkl&auml;rung</h1>
              <h2>1. Datenschutz auf einen Blick</h2>
              <h3>Allgemeine Hinweise</h3>{' '}
              <p>
                Die folgenden Hinweise geben einen einfachen &Uuml;berblick dar&uuml;ber, was mit
                Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
                Personenbezogene Daten sind alle Daten, mit denen Sie pers&ouml;nlich identifiziert
                werden k&ouml;nnen. Ausf&uuml;hrliche Informationen zum Thema Datenschutz entnehmen
                Sie unserer unter diesem Text aufgef&uuml;hrten Datenschutzerkl&auml;rung.
              </p>
              <h3>Datenerfassung auf dieser Website</h3>{' '}
              <h4>Wer ist verantwortlich f&uuml;r die Datenerfassung auf dieser Website?</h4>{' '}
              <p>
                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen
                Kontaktdaten k&ouml;nnen Sie dem Abschnitt &bdquo;Hinweis zur Verantwortlichen
                Stelle&ldquo; in dieser Datenschutzerkl&auml;rung entnehmen.
              </p>{' '}
              <h4>Wie erfassen wir Ihre Daten?</h4>{' '}
              <p>
                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei
                kann es sich z.&nbsp;B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
              </p>{' '}
              <p>
                Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website
                durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.&nbsp;B.
                Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung
                dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
              </p>{' '}
              <h4>Wof&uuml;r nutzen wir Ihre Daten?</h4>{' '}
              <p>
                Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu
                gew&auml;hrleisten. Andere Daten k&ouml;nnen zur Analyse Ihres Nutzerverhaltens
                verwendet werden. Sofern &uuml;ber die Website Vertr&auml;ge geschlossen oder
                angebahnt werden k&ouml;nnen, werden die &uuml;bermittelten Daten auch f&uuml;r
                Vertragsangebote, Bestellungen oder sonstige Auftragsanfragen verarbeitet.
              </p>{' '}
              <h4>Welche Rechte haben Sie bez&uuml;glich Ihrer Daten?</h4>{' '}
              <p>
                Sie haben jederzeit das Recht, unentgeltlich Auskunft &uuml;ber Herkunft,
                Empf&auml;nger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten.
                Sie haben au&szlig;erdem ein Recht, die Berichtigung oder L&ouml;schung dieser Daten
                zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben,
                k&ouml;nnen Sie diese Einwilligung jederzeit f&uuml;r die Zukunft widerrufen.
                Au&szlig;erdem haben Sie das Recht, unter bestimmten Umst&auml;nden die
                Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Des
                Weiteren steht Ihnen ein Beschwerderecht bei der zust&auml;ndigen
                Aufsichtsbeh&ouml;rde zu.
              </p>{' '}
              <p>
                Hierzu sowie zu weiteren Fragen zum Thema Datenschutz k&ouml;nnen Sie sich jederzeit
                an uns wenden.
              </p>
              <h3>Analyse-Tools und Tools von Dritt&shy;anbietern</h3>{' '}
              <p>
                Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden.
                Das geschieht vor allem mit sogenannten Analyseprogrammen.
              </p>{' '}
              <p>
                Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in der folgenden
                Datenschutzerkl&auml;rung.
              </p>
              <h2>2. Allgemeine Hinweise und Pflicht&shy;informationen</h2>
              <h3>Datenschutz</h3>{' '}
              <p>
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer pers&ouml;nlichen Daten sehr
                ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den
                gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerkl&auml;rung.
              </p>{' '}
              <p>
                Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben.
                Personenbezogene Daten sind Daten, mit denen Sie pers&ouml;nlich identifiziert
                werden k&ouml;nnen. Die vorliegende Datenschutzerkl&auml;rung erl&auml;utert, welche
                Daten wir erheben und wof&uuml;r wir sie nutzen. Sie erl&auml;utert auch, wie und zu
                welchem Zweck das geschieht.
              </p>{' '}
              <p>
                Wir weisen darauf hin, dass die Daten&uuml;bertragung im Internet (z.&nbsp;B. bei
                der Kommunikation per E-Mail) Sicherheitsl&uuml;cken aufweisen kann. Ein
                l&uuml;ckenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht
                m&ouml;glich.
              </p>
              <h3>Hinweis zur verantwortlichen Stelle</h3>{' '}
              <p>
                Die verantwortliche Stelle f&uuml;r die Datenverarbeitung auf dieser Website ist:
              </p>{' '}
              <p>
                2x4 Solutions GmbH
                <br />
                Fichtenring 8<br />
                84562 Mettenheim
                <br />
                Deutschland
              </p>
              <p>
                Telefon: +49 8631 607164
                <br />
                E-Mail: info@2x4.de
              </p>
              <p>
                Verantwortliche Stelle ist die nat&uuml;rliche oder juristische Person, die allein
                oder gemeinsam mit anderen &uuml;ber die Zwecke und Mittel der Verarbeitung von
                personenbezogenen Daten (z.&nbsp;B. Namen, E-Mail-Adressen o. &Auml;.) entscheidet.
              </p>
              <h3>Speicherdauer</h3>{' '}
              <p>
                Soweit innerhalb dieser Datenschutzerkl&auml;rung keine speziellere Speicherdauer
                genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck
                f&uuml;r die Datenverarbeitung entf&auml;llt. Wenn Sie ein berechtigtes
                L&ouml;schersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung
                widerrufen, werden Ihre Daten gel&ouml;scht, sofern wir keine anderen rechtlich
                zul&auml;ssigen Gr&uuml;nde f&uuml;r die Speicherung Ihrer personenbezogenen Daten
                haben (z.&nbsp;B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im
                letztgenannten Fall erfolgt die L&ouml;schung nach Fortfall dieser Gr&uuml;nde.
              </p>
              <h3>
                Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser Website
              </h3>{' '}
              <p>
                Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre
                personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9
                Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien nach Art. 9 Abs. 1 DSGVO
                verarbeitet werden. Im Falle einer ausdr&uuml;cklichen Einwilligung in die
                &Uuml;bertragung personenbezogener Daten in Drittstaaten erfolgt die
                Datenverarbeitung au&szlig;erdem auf Grundlage von Art. 49 Abs. 1 lit. a DSGVO.
                Sofern Sie in die Speicherung von Cookies oder in den Zugriff auf Informationen in
                Ihr Endger&auml;t (z.&nbsp;B. via Device-Fingerprinting) eingewilligt haben, erfolgt
                die Datenverarbeitung zus&auml;tzlich auf Grundlage von &sect; 25 Abs. 1 TDDDG. Die
                Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur Vertragserf&uuml;llung
                oder zur Durchf&uuml;hrung vorvertraglicher Ma&szlig;nahmen erforderlich,
                verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs. 1 lit. b DSGVO. Des
                Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erf&uuml;llung einer
                rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1 lit. c
                DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten
                Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. &Uuml;ber die jeweils im
                Einzelfall einschl&auml;gigen Rechtsgrundlagen wird in den folgenden Abs&auml;tzen
                dieser Datenschutzerkl&auml;rung informiert.
              </p>
              <h3>Empfänger von personenbezogenen Daten</h3>{' '}
              <p>
                Im Rahmen unserer Gesch&auml;ftst&auml;tigkeit arbeiten wir mit verschiedenen
                externen Stellen zusammen. Dabei ist teilweise auch eine &Uuml;bermittlung von
                personenbezogenen Daten an diese externen Stellen erforderlich. Wir geben
                personenbezogene Daten nur dann an externe Stellen weiter, wenn dies im Rahmen einer
                Vertragserf&uuml;llung erforderlich ist, wenn wir gesetzlich hierzu verpflichtet
                sind (z.&nbsp;B. Weitergabe von Daten an Steuerbeh&ouml;rden), wenn wir ein
                berechtigtes Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe haben oder
                wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt. Beim Einsatz von
                Auftragsverarbeitern geben wir personenbezogene Daten unserer Kunden nur auf
                Grundlage eines g&uuml;ltigen Vertrags &uuml;ber Auftragsverarbeitung weiter. Im
                Falle einer gemeinsamen Verarbeitung wird ein Vertrag &uuml;ber gemeinsame
                Verarbeitung geschlossen.
              </p>
              <h3>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>{' '}
              <p>
                Viele Datenverarbeitungsvorg&auml;nge sind nur mit Ihrer ausdr&uuml;cklichen
                Einwilligung m&ouml;glich. Sie k&ouml;nnen eine bereits erteilte Einwilligung
                jederzeit widerrufen. Die Rechtm&auml;&szlig;igkeit der bis zum Widerruf erfolgten
                Datenverarbeitung bleibt vom Widerruf unber&uuml;hrt.
              </p>
              <h3>
                Widerspruchsrecht gegen die Datenerhebung in besonderen F&auml;llen sowie gegen
                Direktwerbung (Art. 21 DSGVO)
              </h3>{' '}
              <p>
                WENN DIE DATENVERARBEITUNG AUF GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO
                ERFOLGT, HABEN SIE JEDERZEIT DAS RECHT, AUS GR&Uuml;NDEN, DIE SICH AUS IHRER
                BESONDEREN SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN DATEN
                WIDERSPRUCH EINZULEGEN; DIES GILT AUCH F&Uuml;R EIN AUF DIESE BESTIMMUNGEN
                GEST&Uuml;TZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE, AUF DENEN EINE
                VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER DATENSCHUTZERKL&Auml;RUNG. WENN SIE
                WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN PERSONENBEZOGENEN DATEN NICHT MEHR
                VERARBEITEN, ES SEI DENN, WIR K&Ouml;NNEN ZWINGENDE SCHUTZW&Uuml;RDIGE GR&Uuml;NDE
                F&Uuml;R DIE VERARBEITUNG NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN
                &Uuml;BERWIEGEN ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUS&Uuml;BUNG ODER
                VERTEIDIGUNG VON RECHTSANSPR&Uuml;CHEN (WIDERSPRUCH NACH ART. 21 ABS. 1 DSGVO).
              </p>{' '}
              <p>
                WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM DIREKTWERBUNG ZU BETREIBEN, SO
                HABEN SIE DAS RECHT, JEDERZEIT WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER
                PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN; DIES GILT AUCH
                F&Uuml;R DAS PROFILING, SOWEIT ES MIT SOLCHER DIREKTWERBUNG IN VERBINDUNG STEHT.
                WENN SIE WIDERSPRECHEN, WERDEN IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR
                ZUM ZWECKE DER DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
              </p>
              <h3>Beschwerde&shy;recht bei der zust&auml;ndigen Aufsichts&shy;beh&ouml;rde</h3>{' '}
              <p>
                Im Falle von Verst&ouml;&szlig;en gegen die DSGVO steht den Betroffenen ein
                Beschwerderecht bei einer Aufsichtsbeh&ouml;rde, insbesondere in dem Mitgliedstaat
                ihres gew&ouml;hnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des
                mutma&szlig;lichen Versto&szlig;es zu. Das Beschwerderecht besteht unbeschadet
                anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.
              </p>
              <h3>Recht auf Daten&shy;&uuml;bertrag&shy;barkeit</h3>{' '}
              <p>
                Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in
                Erf&uuml;llung eines Vertrags automatisiert verarbeiten, an sich oder an einen
                Dritten in einem g&auml;ngigen, maschinenlesbaren Format aush&auml;ndigen zu lassen.
                Sofern Sie die direkte &Uuml;bertragung der Daten an einen anderen Verantwortlichen
                verlangen, erfolgt dies nur, soweit es technisch machbar ist.
              </p>
              <h3>Auskunft, Berichtigung und L&ouml;schung</h3>{' '}
              <p>
                Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf
                unentgeltliche Auskunft &uuml;ber Ihre gespeicherten personenbezogenen Daten, deren
                Herkunft und Empf&auml;nger und den Zweck der Datenverarbeitung und ggf. ein Recht
                auf Berichtigung oder L&ouml;schung dieser Daten. Hierzu sowie zu weiteren Fragen
                zum Thema personenbezogene Daten k&ouml;nnen Sie sich jederzeit an uns wenden.
              </p>
              <h3>Recht auf Einschr&auml;nkung der Verarbeitung</h3>{' '}
              <p>
                Sie haben das Recht, die Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen
                Daten zu verlangen. Hierzu k&ouml;nnen Sie sich jederzeit an uns wenden. Das Recht
                auf Einschr&auml;nkung der Verarbeitung besteht in folgenden F&auml;llen:
              </p>{' '}
              <ul>
                {' '}
                <li>
                  Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten
                  bestreiten, ben&ouml;tigen wir in der Regel Zeit, um dies zu &uuml;berpr&uuml;fen.
                  F&uuml;r die Dauer der Pr&uuml;fung haben Sie das Recht, die Einschr&auml;nkung
                  der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                </li>{' '}
                <li>
                  Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtm&auml;&szlig;ig
                  geschah/geschieht, k&ouml;nnen Sie statt der L&ouml;schung die Einschr&auml;nkung
                  der Datenverarbeitung verlangen.
                </li>{' '}
                <li>
                  Wenn wir Ihre personenbezogenen Daten nicht mehr ben&ouml;tigen, Sie sie jedoch
                  zur Aus&uuml;bung, Verteidigung oder Geltendmachung von Rechtsanspr&uuml;chen
                  ben&ouml;tigen, haben Sie das Recht, statt der L&ouml;schung die
                  Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                </li>{' '}
                <li>
                  Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine
                  Abw&auml;gung zwischen Ihren und unseren Interessen vorgenommen werden. Solange
                  noch nicht feststeht, wessen Interessen &uuml;berwiegen, haben Sie das Recht, die
                  Einschr&auml;nkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                </li>{' '}
              </ul>{' '}
              <p>
                Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschr&auml;nkt haben,
                d&uuml;rfen diese Daten &ndash; von ihrer Speicherung abgesehen &ndash; nur mit
                Ihrer Einwilligung oder zur Geltendmachung, Aus&uuml;bung oder Verteidigung von
                Rechtsanspr&uuml;chen oder zum Schutz der Rechte einer anderen nat&uuml;rlichen oder
                juristischen Person oder aus Gr&uuml;nden eines wichtigen &ouml;ffentlichen
                Interesses der Europ&auml;ischen Union oder eines Mitgliedstaats verarbeitet werden.
              </p>
              <h3>SSL- bzw. TLS-Verschl&uuml;sselung</h3>{' '}
              <p>
                Diese Seite nutzt aus Sicherheitsgr&uuml;nden und zum Schutz der &Uuml;bertragung
                vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns
                als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschl&uuml;sselung. Eine
                verschl&uuml;sselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers
                von &bdquo;http://&ldquo; auf &bdquo;https://&ldquo; wechselt und an dem
                Schloss-Symbol in Ihrer Browserzeile.
              </p>{' '}
              <p>
                Wenn die SSL- bzw. TLS-Verschl&uuml;sselung aktiviert ist, k&ouml;nnen die Daten,
                die Sie an uns &uuml;bermitteln, nicht von Dritten mitgelesen werden.
              </p>
              <h3>Verschl&uuml;sselter Zahlungsverkehr auf dieser Website</h3>{' '}
              <p>
                Besteht nach dem Abschluss eines kostenpflichtigen Vertrags eine Verpflichtung, uns
                Ihre Zahlungsdaten (z.&nbsp;B. Kontonummer bei Einzugserm&auml;chtigung) zu
                &uuml;bermitteln, werden diese Daten zur Zahlungsabwicklung ben&ouml;tigt.
              </p>{' '}
              <p>
                Der Zahlungsverkehr &uuml;ber die g&auml;ngigen Zahlungsmittel (Visa/MasterCard,
                Lastschriftverfahren) erfolgt ausschlie&szlig;lich &uuml;ber eine
                verschl&uuml;sselte SSL- bzw. TLS-Verbindung. Eine verschl&uuml;sselte Verbindung
                erkennen Sie daran, dass die Adresszeile des Browsers von &bdquo;http://&ldquo; auf
                &bdquo;https://&ldquo; wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>{' '}
              <p>
                Bei verschl&uuml;sselter Kommunikation k&ouml;nnen Ihre Zahlungsdaten, die Sie an
                uns &uuml;bermitteln, nicht von Dritten mitgelesen werden.
              </p>
              <h3>Widerspruch gegen Werbe-E-Mails</h3>{' '}
              <p>
                Der Nutzung von im Rahmen der Impressumspflicht ver&ouml;ffentlichten Kontaktdaten
                zur &Uuml;bersendung von nicht ausdr&uuml;cklich angeforderter Werbung und
                Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten
                behalten sich ausdr&uuml;cklich rechtliche Schritte im Falle der unverlangten
                Zusendung von Werbeinformationen, etwa durch Spam-E-Mails, vor.
              </p>
              <h2>3. Datenerfassung auf dieser Website</h2>
              <h3>Cookies</h3>{' '}
              <p>
                Unsere Internetseiten verwenden so genannte &bdquo;Cookies&ldquo;. Cookies sind
                kleine Datenpakete und richten auf Ihrem Endger&auml;t keinen Schaden an. Sie werden
                entweder vor&uuml;bergehend f&uuml;r die Dauer einer Sitzung (Session-Cookies) oder
                dauerhaft (permanente Cookies) auf Ihrem Endger&auml;t gespeichert. Session-Cookies
                werden nach Ende Ihres Besuchs automatisch gel&ouml;scht. Permanente Cookies bleiben
                auf Ihrem Endger&auml;t gespeichert, bis Sie diese selbst l&ouml;schen oder eine
                automatische L&ouml;schung durch Ihren Webbrowser erfolgt.
              </p>{' '}
              <p>
                Cookies k&ouml;nnen von uns (First-Party-Cookies) oder von Drittunternehmen stammen
                (sog. Third-Party-Cookies). Third-Party-Cookies erm&ouml;glichen die Einbindung
                bestimmter Dienstleistungen von Drittunternehmen innerhalb von Webseiten (z.&nbsp;B.
                Cookies zur Abwicklung von Zahlungsdienstleistungen).
              </p>{' '}
              <p>
                Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch notwendig,
                da bestimmte Webseitenfunktionen ohne diese nicht funktionieren w&uuml;rden
                (z.&nbsp;B. die Warenkorbfunktion oder die Anzeige von Videos). Andere Cookies
                k&ouml;nnen zur Auswertung des Nutzerverhaltens oder zu Werbezwecken verwendet
                werden.
              </p>{' '}
              <p>
                Cookies, die zur Durchf&uuml;hrung des elektronischen Kommunikationsvorgangs, zur
                Bereitstellung bestimmter, von Ihnen erw&uuml;nschter Funktionen (z.&nbsp;B.
                f&uuml;r die Warenkorbfunktion) oder zur Optimierung der Website (z.&nbsp;B. Cookies
                zur Messung des Webpublikums) erforderlich sind (notwendige Cookies), werden auf
                Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere
                Rechtsgrundlage angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse
                an der Speicherung von notwendigen Cookies zur technisch fehlerfreien und
                optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung zur Speicherung
                von Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt wurde, erfolgt
                die Verarbeitung ausschlie&szlig;lich auf Grundlage dieser Einwilligung (Art. 6 Abs.
                1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG); die Einwilligung ist jederzeit
                widerrufbar.
              </p>{' '}
              <p>
                Sie k&ouml;nnen Ihren Browser so einstellen, dass Sie &uuml;ber das Setzen von
                Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von
                Cookies f&uuml;r bestimmte F&auml;lle oder generell ausschlie&szlig;en sowie das
                automatische L&ouml;schen der Cookies beim Schlie&szlig;en des Browsers aktivieren.
                Bei der Deaktivierung von Cookies kann die Funktionalit&auml;t dieser Website
                eingeschr&auml;nkt sein.
              </p>{' '}
              <p>
                Welche Cookies und Dienste auf dieser Website eingesetzt werden, k&ouml;nnen Sie
                dieser Datenschutzerkl&auml;rung entnehmen.
              </p>
              <h3>Server-Log-Dateien</h3>{' '}
              <p>
                Der Provider der Seiten erhebt und speichert automatisch Informationen in so
                genannten Server-Log-Dateien, die Ihr Browser automatisch an uns &uuml;bermittelt.
                Dies sind:
              </p>{' '}
              <ul>
                {' '}
                <li>Browsertyp und Browserversion</li> <li>verwendetes Betriebssystem</li>{' '}
                <li>Referrer URL</li> <li>Hostname des zugreifenden Rechners</li>{' '}
                <li>Uhrzeit der Serveranfrage</li> <li>IP-Adresse</li>{' '}
              </ul>{' '}
              <p>
                Eine Zusammenf&uuml;hrung dieser Daten mit anderen Datenquellen wird nicht
                vorgenommen.
              </p>{' '}
              <p>
                Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
                Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien
                Darstellung und der Optimierung seiner Website &ndash; hierzu m&uuml;ssen die
                Server-Log-Files erfasst werden.
              </p>
              <h3>Kontaktformular</h3>{' '}
              <p>
                Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus
                dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
                Bearbeitung der Anfrage und f&uuml;r den Fall von Anschlussfragen bei uns
                gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>{' '}
              <p>
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO,
                sofern Ihre Anfrage mit der Erf&uuml;llung eines Vertrags zusammenh&auml;ngt oder
                zur Durchf&uuml;hrung vorvertraglicher Ma&szlig;nahmen erforderlich ist. In allen
                &uuml;brigen F&auml;llen beruht die Verarbeitung auf unserem berechtigten Interesse
                an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f
                DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese
                abgefragt wurde; die Einwilligung ist jederzeit widerrufbar.
              </p>{' '}
              <p>
                Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns
                zur L&ouml;schung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der
                Zweck f&uuml;r die Datenspeicherung entf&auml;llt (z.&nbsp;B. nach abgeschlossener
                Bearbeitung Ihrer Anfrage). Zwingende gesetzliche Bestimmungen &ndash; insbesondere
                Aufbewahrungsfristen &ndash; bleiben unber&uuml;hrt.
              </p>
              <h3>Anfrage per E-Mail, Telefon oder Telefax</h3>{' '}
              <p>
                Wenn Sie uns per E-Mail, Telefon oder Telefax kontaktieren, wird Ihre Anfrage
                inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum
                Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese
                Daten geben wir nicht ohne Ihre Einwilligung weiter.
              </p>{' '}
              <p>
                Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO,
                sofern Ihre Anfrage mit der Erf&uuml;llung eines Vertrags zusammenh&auml;ngt oder
                zur Durchf&uuml;hrung vorvertraglicher Ma&szlig;nahmen erforderlich ist. In allen
                &uuml;brigen F&auml;llen beruht die Verarbeitung auf unserem berechtigten Interesse
                an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f
                DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese
                abgefragt wurde; die Einwilligung ist jederzeit widerrufbar.
              </p>{' '}
              <p>
                Die von Ihnen an uns per Kontaktanfragen &uuml;bersandten Daten verbleiben bei uns,
                bis Sie uns zur L&ouml;schung auffordern, Ihre Einwilligung zur Speicherung
                widerrufen oder der Zweck f&uuml;r die Datenspeicherung entf&auml;llt (z.&nbsp;B.
                nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende gesetzliche
                Bestimmungen &ndash; insbesondere gesetzliche Aufbewahrungsfristen &ndash; bleiben
                unber&uuml;hrt.
              </p>
              <h3>Registrierung auf dieser Website</h3>{' '}
              <p>
                Sie k&ouml;nnen sich auf dieser Website registrieren, um zus&auml;tzliche Funktionen
                auf der Seite zu nutzen. Die dazu eingegebenen Daten verwenden wir nur zum Zwecke
                der Nutzung des jeweiligen Angebotes oder Dienstes, f&uuml;r den Sie sich
                registriert haben. Die bei der Registrierung abgefragten Pflichtangaben m&uuml;ssen
                vollst&auml;ndig angegeben werden. Anderenfalls werden wir die Registrierung
                ablehnen.
              </p>{' '}
              <p>
                F&uuml;r wichtige &Auml;nderungen etwa beim Angebotsumfang oder bei technisch
                notwendigen &Auml;nderungen nutzen wir die bei der Registrierung angegebene
                E-Mail-Adresse, um Sie auf diesem Wege zu informieren.
              </p>{' '}
              <p>
                Die Verarbeitung der bei der Registrierung eingegebenen Daten erfolgt zum Zwecke der
                Durchf&uuml;hrung des durch die Registrierung begr&uuml;ndeten
                Nutzungsverh&auml;ltnisses und ggf. zur Anbahnung weiterer Vertr&auml;ge (Art. 6
                Abs. 1 lit. b DSGVO).
              </p>{' '}
              <p>
                Die bei der Registrierung erfassten Daten werden von uns gespeichert, solange Sie
                auf dieser Website registriert sind und werden anschlie&szlig;end gel&ouml;scht.
                Gesetzliche Aufbewahrungsfristen bleiben unber&uuml;hrt.
              </p>
              <h3>Kommentar&shy;funktion auf dieser Website</h3>{' '}
              <p>
                F&uuml;r die Kommentarfunktion auf dieser Seite werden neben Ihrem Kommentar auch
                Angaben zum Zeitpunkt der Erstellung des Kommentars, Ihre E-Mail-Adresse und, wenn
                Sie nicht anonym posten, der von Ihnen gew&auml;hlte Nutzername gespeichert.
              </p>
              <h4>Speicherung der IP-Adresse</h4>{' '}
              <p>
                Unsere Kommentarfunktion speichert die IP-Adressen der Nutzer, die Kommentare
                verfassen. Da wir Kommentare auf dieser Website nicht vor der Freischaltung
                pr&uuml;fen, ben&ouml;tigen wir diese Daten, um im Falle von Rechtsverletzungen wie
                Beleidigungen oder Propaganda gegen den Verfasser vorgehen zu k&ouml;nnen.
              </p>
              <h4>Abonnieren von Kommentaren</h4>{' '}
              <p>
                Als Nutzer der Seite k&ouml;nnen Sie nach einer Anmeldung Kommentare abonnieren. Sie
                erhalten eine Best&auml;tigungsemail, um zu pr&uuml;fen, ob Sie der Inhaber der
                angegebenen E-Mail-Adresse sind. Sie k&ouml;nnen diese Funktion jederzeit &uuml;ber
                einen Link in den Info-Mails abbestellen. Die im Rahmen des Abonnierens von
                Kommentaren eingegebenen Daten werden in diesem Fall gel&ouml;scht; wenn Sie diese
                Daten f&uuml;r andere Zwecke und an anderer Stelle (z.&nbsp;B. Newsletterbestellung)
                an uns &uuml;bermittelt haben, verbleiben diese Daten jedoch bei uns.
              </p>
              <h4>Speicherdauer der Kommentare</h4>{' '}
              <p>
                Die Kommentare und die damit verbundenen Daten werden gespeichert und verbleiben auf
                dieser Website, bis der kommentierte Inhalt vollst&auml;ndig gel&ouml;scht wurde
                oder die Kommentare aus rechtlichen Gr&uuml;nden gel&ouml;scht werden m&uuml;ssen
                (z.&nbsp;B. beleidigende Kommentare).
              </p>
              <h4>Rechtsgrundlage</h4>{' '}
              <p>
                Die Speicherung der Kommentare erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs.
                1 lit. a DSGVO). Sie k&ouml;nnen eine von Ihnen erteilte Einwilligung jederzeit
                widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die
                Rechtm&auml;&szlig;igkeit der bereits erfolgten Datenverarbeitungsvorg&auml;nge
                bleibt vom Widerruf unber&uuml;hrt.
              </p>
              <h2>4. Analyse-Tools und Werbung</h2>
              <h3>Google Analytics</h3>{' '}
              <p>
                Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter ist
                die Google Ireland Limited (&bdquo;Google&ldquo;), Gordon House, Barrow Street,
                Dublin 4, Irland.
              </p>{' '}
              <p>
                Google Analytics erm&ouml;glicht es dem Websitebetreiber, das Verhalten der
                Websitebesucher zu analysieren. Hierbei erh&auml;lt der Websitebetreiber
                verschiedene Nutzungsdaten, wie z.&nbsp;B. Seitenaufrufe, Verweildauer, verwendete
                Betriebssysteme und Herkunft des Nutzers. Diese Daten werden dem jeweiligen Endgerät
                des Users zugeordnet. Eine Zuordnung zu einer User-ID erfolgt nicht.
              </p>{' '}
              <p>
                Des Weiteren k&ouml;nnen wir mit Google Analytics u.&nbsp;a. Ihre Maus- und
                Scrollbewegungen und Klicks aufzeichnen. Ferner verwendet Google Analytics
                verschiedene Modellierungsans&auml;tze, um die erfassten Datens&auml;tze zu
                erg&auml;nzen und setzt Machine-Learning-Technologien bei der Datenanalyse ein.
              </p>
              <p>
                Google Analytics verwendet Technologien, die die Wiedererkennung des Nutzers zum
                Zwecke der Analyse des Nutzerverhaltens erm&ouml;glichen (z.&nbsp;B. Cookies oder
                Device-Fingerprinting). Die von Google erfassten Informationen &uuml;ber die
                Benutzung dieser Website werden in der Regel an einen Server von Google in den USA
                &uuml;bertragen und dort gespeichert.
              </p>{' '}
              <p>
                Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6
                Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit
                widerrufbar.
              </p>{' '}
              <p>
                Die Daten&uuml;bertragung in die USA wird auf die Standardvertragsklauseln der
                EU-Kommission gest&uuml;tzt. Details finden Sie hier:{' '}
                <a
                  href="https://privacy.google.com/businesses/controllerterms/mccs/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://privacy.google.com/businesses/controllerterms/mccs/
                </a>
                .
              </p>{' '}
              <p>
                Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem &bdquo;EU-US
                Data Privacy Framework&ldquo; (DPF). Der DPF ist ein &Uuml;bereinkommen zwischen der
                Europ&auml;ischen Union und den USA, der die Einhaltung europ&auml;ischer
                Datenschutzstandards bei Datenverarbeitungen in den USA gew&auml;hrleisten soll.
                Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese
                Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom
                Anbieter unter folgendem Link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/5780"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/5780
                </a>
                .
              </p>
              <h4>IP Anonymisierung</h4>{' '}
              <p>
                Die Google Analytics IP-Anonymisierung ist aktiviert. Dadurch wird Ihre IP-Adresse
                von Google innerhalb von Mitgliedstaaten der Europ&auml;ischen Union oder in anderen
                Vertragsstaaten des Abkommens &uuml;ber den Europ&auml;ischen Wirtschaftsraum vor
                der &Uuml;bermittlung in die USA gek&uuml;rzt. Nur in Ausnahmef&auml;llen wird die
                volle IP-Adresse an einen Server von Google in den USA &uuml;bertragen und dort
                gek&uuml;rzt. Im Auftrag des Betreibers dieser Website wird Google diese
                Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports
                &uuml;ber die Websiteaktivit&auml;ten zusammenzustellen und um weitere mit der
                Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegen&uuml;ber
                dem Websitebetreiber zu erbringen. Die im Rahmen von Google Analytics von Ihrem
                Browser &uuml;bermittelte IP-Adresse wird nicht mit anderen Daten von Google
                zusammengef&uuml;hrt.
              </p>
              <h4>Browser Plugin</h4>{' '}
              <p>
                Sie k&ouml;nnen die Erfassung und Verarbeitung Ihrer Daten durch Google verhindern,
                indem Sie das unter dem folgenden Link verf&uuml;gbare Browser-Plugin herunterladen
                und installieren:{' '}
                <a
                  href="https://tools.google.com/dlpage/gaoptout?hl=de"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tools.google.com/dlpage/gaoptout?hl=de
                </a>
                .
              </p>{' '}
              <p>
                Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in der
                Datenschutzerkl&auml;rung von Google:{' '}
                <a
                  href="https://support.google.com/analytics/answer/6004245?hl=de"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://support.google.com/analytics/answer/6004245?hl=de
                </a>
                .
              </p>
              <h4>Auftragsverarbeitung</h4>{' '}
              <p>
                Wir haben mit Google einen Vertrag zur Auftragsverarbeitung abgeschlossen und setzen
                die strengen Vorgaben der deutschen Datenschutzbeh&ouml;rden bei der Nutzung von
                Google Analytics vollst&auml;ndig um.
              </p>
              <h3>Google Ads</h3>{' '}
              <p>
                Der Websitebetreiber verwendet Google Ads. Google Ads ist ein Online-Werbeprogramm
                der Google Ireland Limited (&bdquo;Google&ldquo;), Gordon House, Barrow Street,
                Dublin 4, Irland.
              </p>{' '}
              <p>
                Google Ads erm&ouml;glicht es uns Werbeanzeigen in der Google-Suchmaschine oder auf
                Drittwebseiten auszuspielen, wenn der Nutzer bestimmte Suchbegriffe bei Google
                eingibt (Keyword-Targeting). Ferner k&ouml;nnen zielgerichtete Werbeanzeigen anhand
                der bei Google vorhandenen Nutzerdaten (z.&nbsp;B. Standortdaten und Interessen)
                ausgespielt werden (Zielgruppen-Targeting). Wir als Websitebetreiber k&ouml;nnen
                diese Daten quantitativ auswerten, indem wir beispielsweise analysieren, welche
                Suchbegriffe zur Ausspielung unserer Werbeanzeigen gef&uuml;hrt haben und wie viele
                Anzeigen zu entsprechenden Klicks gef&uuml;hrt haben.
              </p>{' '}
              <p>
                Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6
                Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit
                widerrufbar.
              </p>{' '}
              <p>
                Die Daten&uuml;bertragung in die USA wird auf die Standardvertragsklauseln der
                EU-Kommission gest&uuml;tzt. Details finden Sie hier:{' '}
                <a
                  href="https://policies.google.com/privacy/frameworks"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://policies.google.com/privacy/frameworks
                </a>{' '}
                und{' '}
                <a
                  href="https://business.safety.google/controllerterms/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://business.safety.google/controllerterms/
                </a>
                .
              </p>
              <p>
                Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem &bdquo;EU-US
                Data Privacy Framework&ldquo; (DPF). Der DPF ist ein &Uuml;bereinkommen zwischen der
                Europ&auml;ischen Union und den USA, der die Einhaltung europ&auml;ischer
                Datenschutzstandards bei Datenverarbeitungen in den USA gew&auml;hrleisten soll.
                Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese
                Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom
                Anbieter unter folgendem Link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/5780"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/5780
                </a>
                .
              </p>
              <h3>Google Ads Remarketing</h3>{' '}
              <p>
                Diese Website nutzt die Funktionen von Google Ads Remarketing. Anbieter ist die
                Google Ireland Limited (&bdquo;Google&ldquo;), Gordon House, Barrow Street, Dublin
                4, Irland.
              </p>{' '}
              <p>
                Mit Google Ads Remarketing k&ouml;nnen wir Personen, die mit unserem Online-Angebot
                interagieren bestimmten Zielgruppen zuordnen, um ihnen anschlie&szlig;end
                interessenbezogene Werbung im Google-Werbenetzwerk anzeigen zu lassen (Remarketing
                bzw. Retargeting).
              </p>{' '}
              <p>
                Des Weiteren k&ouml;nnen die mit Google Ads Remarketing erstellten Werbe-Zielgruppen
                mit den ger&auml;te&uuml;bergreifenden Funktionen von Google verkn&uuml;pft werden.
                Auf diese Weise k&ouml;nnen interessenbezogene, personalisierte Werbebotschaften,
                die in Abh&auml;ngigkeit Ihres fr&uuml;heren Nutzungs- und Surfverhaltens auf einem
                Endger&auml;t (z.&nbsp;B. Handy) an Sie angepasst wurden auch auf einem anderen
                Ihrer Endger&auml;te (z.&nbsp;B. Tablet oder PC) angezeigt werden.
              </p>{' '}
              <p>
                Wenn Sie &uuml;ber einen Google-Account verf&uuml;gen, k&ouml;nnen Sie der
                personalisierten Werbung unter folgendem Link widersprechen:{' '}
                <a
                  href="https://adssettings.google.com/anonymous?hl=de"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://adssettings.google.com/anonymous?hl=de
                </a>
                .
              </p>{' '}
              <p>
                Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6
                Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit
                widerrufbar.
              </p>{' '}
              <p>
                Weitergehende Informationen und die Datenschutzbestimmungen finden Sie in der
                Datenschutzerkl&auml;rung von Google unter:{' '}
                <a
                  href="https://policies.google.com/technologies/ads?hl=de"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://policies.google.com/technologies/ads?hl=de
                </a>
                .
              </p>
              <p>
                Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem &bdquo;EU-US
                Data Privacy Framework&ldquo; (DPF). Der DPF ist ein &Uuml;bereinkommen zwischen der
                Europ&auml;ischen Union und den USA, der die Einhaltung europ&auml;ischer
                Datenschutzstandards bei Datenverarbeitungen in den USA gew&auml;hrleisten soll.
                Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese
                Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom
                Anbieter unter folgendem Link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/5780"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/5780
                </a>
                .
              </p>
              <h3>Google Conversion-Tracking</h3>{' '}
              <p>
                Diese Website nutzt Google Conversion Tracking. Anbieter ist die Google Ireland
                Limited (&bdquo;Google&ldquo;), Gordon House, Barrow Street, Dublin 4, Irland.
              </p>{' '}
              <p>
                Mit Hilfe von Google-Conversion-Tracking k&ouml;nnen Google und wir erkennen, ob der
                Nutzer bestimmte Aktionen durchgef&uuml;hrt hat. So k&ouml;nnen wir beispielsweise
                auswerten, welche Buttons auf unserer Website wie h&auml;ufig geklickt und welche
                Produkte besonders h&auml;ufig angesehen oder gekauft wurden. Diese Informationen
                dienen dazu, Conversion-Statistiken zu erstellen. Wir erfahren die Gesamtanzahl der
                Nutzer, die auf unsere Anzeigen geklickt haben und welche Aktionen sie
                durchgef&uuml;hrt haben. Wir erhalten keine Informationen, mit denen wir den Nutzer
                pers&ouml;nlich identifizieren k&ouml;nnen. Google selbst nutzt zur Identifikation
                Cookies oder vergleichbare Wiedererkennungstechnologien.
              </p>{' '}
              <p>
                Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6
                Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit
                widerrufbar.
              </p>{' '}
              <p>
                Mehr Informationen zu Google Conversion-Tracking finden Sie in den
                Datenschutzbestimmungen von Google:{' '}
                <a
                  href="https://policies.google.com/privacy?hl=de"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://policies.google.com/privacy?hl=de
                </a>
                .
              </p>
              <p>
                Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem &bdquo;EU-US
                Data Privacy Framework&ldquo; (DPF). Der DPF ist ein &Uuml;bereinkommen zwischen der
                Europ&auml;ischen Union und den USA, der die Einhaltung europ&auml;ischer
                Datenschutzstandards bei Datenverarbeitungen in den USA gew&auml;hrleisten soll.
                Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese
                Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom
                Anbieter unter folgendem Link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/5780"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/5780
                </a>
                .
              </p>
              <h3>LinkedIn Insight Tag</h3>{' '}
              <p>
                Diese Website nutzt das Insight-Tag von LinkedIn. Anbieter dieses Dienstes ist die
                LinkedIn Ireland Unlimited Company, Wilton Plaza, Wilton Place, Dublin 2, Irland.
              </p>{' '}
              <h4>Datenverarbeitung durch LinkedIn Insight Tag</h4>{' '}
              <p>
                Mit Hilfe des LinkedIn Insight Tags erhalten wir Informationen &uuml;ber die
                Besucher unserer Website. Ist ein Websitebesucher bei LinkedIn registriert,
                k&ouml;nnen wir u.&nbsp;a. die beruflichen Eckdaten (z.&nbsp;B. Karrierestufe,
                Unternehmensgr&ouml;&szlig;e, Land, Standort, Branche und Berufsbezeichnung) unserer
                Websitebesucher analysieren und so unsere Seite besser auf die jeweiligen
                Zielgruppen ausrichten. Ferner k&ouml;nnen wir mit Hilfe von LinkedIn Insight Tags
                messen, ob die Besucher unserer Webseiten einen Kauf oder eine sonstige Aktion
                t&auml;tigen (Conversion-Messung). Die Conversion-Messung kann auch
                ger&auml;te&uuml;bergreifend erfolgen (z.&nbsp;B. von PC zu Tablet). LinkedIn
                Insight Tag bietet au&szlig;erdem eine Retargeting-Funktion an, mit deren Hilfe wir
                den Besuchern unserer Website zielgerichtete Werbung au&szlig;erhalb der Website
                anzeigen lassen k&ouml;nnen, wobei laut LinkedIn keine Identifikation des
                Werbeadressaten stattfindet.
              </p>{' '}
              <p>
                LinkedIn selbst erfasst au&szlig;erdem sogenannte Logfiles (URL, Referrer-URL,
                IP-Adresse, Ger&auml;te- und Browsereigenschaften und Zeitpunkt des Zugriffs). Die
                IP-Adressen werden gek&uuml;rzt oder (sofern sie genutzt werden, um
                LinkedIn-Mitglieder ger&auml;te&uuml;bergreifend zu erreichen) gehasht
                (pseudonymisiert). Die direkten Kennungen der LinkedIn-Mitglieder werden nach sieben
                Tagen von LinkedIn gel&ouml;scht. Die verbleibenden pseudonymisierten Daten werden
                dann innerhalb von 180 Tagen gel&ouml;scht.
              </p>{' '}
              <p>
                Die von LinkedIn erhobenen Daten k&ouml;nnen von uns als Websitebetreiber nicht
                bestimmten Einzelpersonen zugeordnet werden. LinkedIn wird die erfassten
                personenbezogenen Daten der Websitebesucher auf seinen Servern in den USA speichern
                und sie im Rahmen eigener Werbema&szlig;nahmen nutzen. Details entnehmen Sie der
                Datenschutzerkl&auml;rung von LinkedIn unter{' '}
                <a
                  href="https://www.linkedin.com/legal/privacy-policy#choices-oblig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linkedin.com/legal/privacy-policy#choices-oblig
                </a>
                .
              </p>{' '}
              <h4>Rechtsgrundlage</h4>{' '}
              <p>
                Soweit eine Einwilligung (Consent) eingeholt wurde, erfolgt der Einsatz des
                o.&nbsp;g. Dienstes ausschlie&szlig;lich auf Grundlage von Art. 6 Abs. 1 lit. a
                DSGVO und &sect; 25 TDDDG. Die Einwilligung ist jederzeit widerrufbar. Soweit keine
                Einwilligung eingeholt wurde, erfolgt die Verwendung dieses Dienstes auf Grundlage
                von Art. 6 Abs. 1 lit. f DSGVO; der Websitebetreiber hat ein berechtigtes Interesse
                an effektiven Werbema&szlig;nahmen unter Einschluss der sozialen Medien.
              </p>{' '}
              <p>
                Die Daten&uuml;bertragung in die USA wird auf die Standardvertragsklauseln der
                EU-Kommission gest&uuml;tzt. Details finden Sie hier:{' '}
                <a
                  href="https://www.linkedin.com/legal/l/dpa"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linkedin.com/legal/l/dpa
                </a>{' '}
                und{' '}
                <a
                  href="https://www.linkedin.com/legal/l/eu-sccs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linkedin.com/legal/l/eu-sccs
                </a>
                .
              </p>{' '}
              <p>
                Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem &bdquo;EU-US
                Data Privacy Framework&ldquo; (DPF). Der DPF ist ein &Uuml;bereinkommen zwischen der
                Europ&auml;ischen Union und den USA, der die Einhaltung europ&auml;ischer
                Datenschutzstandards bei Datenverarbeitungen in den USA gew&auml;hrleisten soll.
                Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese
                Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom
                Anbieter unter folgendem Link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/5448"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/5448
                </a>
                .
              </p>
              <h4>Widerspruch gegen die Verwendung von LinkedIn Insight Tag</h4>{' '}
              <p>
                Der Analyse des Nutzungsverhaltens sowie zielgerichtete Werbung durch LinkedIn unter
                folgendem Link widersprechen:{' '}
                <a
                  href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
                </a>
                .
              </p>{' '}
              <p>
                Des Weiteren k&ouml;nnen Mitglieder von LinkedIn die Nutzung ihrer personenbezogenen
                Daten zu Werbezwecken in den Kontoeinstellungen steuern. Um einer Verkn&uuml;pfung
                von auf unserer Website erhobenen Daten durch LinkedIn und Ihrem LinkedIn Account zu
                vermeiden, m&uuml;ssen Sie sich aus Ihrem LinkedIn-Account ausloggen bevor Sie
                unsere Website aufsuchen.
              </p>
              <h4>Auftragsverarbeitung</h4>{' '}
              <p>
                Wir haben einen Vertrag &uuml;ber Auftragsverarbeitung (AVV) zur Nutzung des oben
                genannten Dienstes geschlossen. Hierbei handelt es sich um einen
                datenschutzrechtlich vorgeschriebenen Vertrag, der gew&auml;hrleistet, dass dieser
                die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und
                unter Einhaltung der DSGVO verarbeitet.
              </p>
              <h2>5. Newsletter</h2>
              <h3>Newsletter&shy;daten</h3>{' '}
              <p>
                Wenn Sie den auf der Website angebotenen Newsletter beziehen m&ouml;chten,
                ben&ouml;tigen wir von Ihnen eine E-Mail-Adresse sowie Informationen, welche uns die
                &Uuml;berpr&uuml;fung gestatten, dass Sie der Inhaber der angegebenen E-Mail-Adresse
                und mit dem Empfang des Newsletters einverstanden sind. Weitere Daten werden nicht
                bzw. nur auf freiwilliger Basis erhoben. F&uuml;r die Abwicklung der Newsletter
                nutzen wir Newsletterdiensteanbieter, die nachfolgend beschrieben werden.
              </p>
              <h3>Brevo</h3>{' '}
              <p>
                Diese Website nutzt Brevo f&uuml;r den Versand von Newslettern. Anbieter ist die
                Sendinblue GmbH, K&ouml;penicker Stra&szlig;e 126, 10179 Berlin, Deutschland.
              </p>{' '}
              <p>
                Brevo ist ein Dienst, mit dem u.a. der Versand von Newslettern organisiert und
                analysiert werden kann. Die von Ihnen zum Zwecke des Newsletterbezugs eingegeben
                Daten werden auf den Servern der Sendinblue GmbH in Deutschland gespeichert.
              </p>{' '}
              <h4>Datenanalyse durch Brevo</h4>{' '}
              <p>
                Mit Hilfe von Brevo ist es uns m&ouml;glich, unsere Newsletter-Kampagnen zu
                analysieren. So k&ouml;nnen wir z.&nbsp;B. sehen, ob eine Newsletter-Nachricht
                ge&ouml;ffnet und welche Links ggf. angeklickt wurden. Auf diese Weise k&ouml;nnen
                wir u.a. feststellen, welche Links besonders oft angeklickt wurden.
              </p>{' '}
              <p>
                Au&szlig;erdem k&ouml;nnen wir erkennen, ob nach dem &Ouml;ffnen/ Anklicken
                bestimmte vorher definierte Aktionen durchgef&uuml;hrt wurden (Conversion-Rate). Wir
                k&ouml;nnen so z.&nbsp;B. erkennen, ob Sie nach dem Anklicken des Newsletters einen
                Kauf get&auml;tigt haben.
              </p>{' '}
              <p>
                Brevo erm&ouml;glicht es uns auch, die Newsletter-Empf&auml;nger anhand
                verschiedener Kategorien zu unterteilen (&bdquo;clustern&ldquo;). Dabei lassen sich
                die Newsletterempf&auml;nger z.&nbsp;B. nach Alter, Geschlecht oder Wohnort
                unterteilen. Auf diese Weise lassen sich die Newsletter besser an die jeweiligen
                Zielgruppen anpassen.
              </p>{' '}
              <p>
                Wenn Sie keine Analyse durch Brevo wollen, m&uuml;ssen Sie den Newsletter
                abbestellen. Hierf&uuml;r stellen wir in jeder Newsletternachricht einen
                entsprechenden Link zur Verf&uuml;gung.
              </p>{' '}
              <p>
                Ausf&uuml;hrliche Informationen zum zu den Funktionen von Brevo entnehmen Sie
                folgendem Link:{' '}
                <a
                  href="https://www.brevo.com/de/newsletter-software/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.brevo.com/de/newsletter-software/
                </a>
                .
              </p>{' '}
              <h4>Rechtsgrundlage</h4>{' '}
              <p>
                Die Datenverarbeitung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a
                DSGVO). Sie k&ouml;nnen diese Einwilligung jederzeit widerrufen. Die
                Rechtm&auml;&szlig;igkeit der bereits erfolgten Datenverarbeitungsvorg&auml;nge
                bleibt vom Widerruf unber&uuml;hrt.
              </p>{' '}
              <h4>Speicherdauer</h4>{' '}
              <p>
                Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten Daten werden von
                uns bis zu Ihrer Austragung aus dem Newsletter bei uns bzw. dem
                Newsletterdiensteanbieter gespeichert und nach der Abbestellung des Newsletters aus
                der Newsletterverteilerliste gel&ouml;scht. Daten, die zu anderen Zwecken bei uns
                gespeichert wurden, bleiben hiervon unber&uuml;hrt.
              </p>{' '}
              <p>
                Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre E-Mail-Adresse bei
                uns bzw. dem Newsletterdiensteanbieter ggf. in einer Blacklist gespeichert, sofern
                dies zur Verhinderung k&uuml;nftiger Mailings erforderlich ist. Die Daten aus der
                Blacklist werden nur f&uuml;r diesen Zweck verwendet und nicht mit anderen Daten
                zusammengef&uuml;hrt. Dies dient sowohl Ihrem Interesse als auch unserem Interesse
                an der Einhaltung der gesetzlichen Vorgaben beim Versand von Newslettern
                (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f DSGVO). Die Speicherung in
                der Blacklist ist zeitlich nicht befristet.{' '}
                <strong>
                  Sie k&ouml;nnen der Speicherung widersprechen, sofern Ihre Interessen unser
                  berechtigtes Interesse &uuml;berwiegen.
                </strong>
              </p>{' '}
              <p>
                N&auml;heres entnehmen Sie den Datenschutzbestimmungen von Brevo unter:{' '}
                <a
                  href="https://www.brevo.com/de/datenschutz-uebersicht/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.brevo.com/de/datenschutz-uebersicht/
                </a>{' '}
                sowie{' '}
                <a
                  href="https://www.brevo.com/de/legal/privacypolicy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.brevo.com/de/legal/privacypolicy/
                </a>
                .
              </p>
              <h4>Auftragsverarbeitung</h4>{' '}
              <p>
                Wir haben einen Vertrag &uuml;ber Auftragsverarbeitung (AVV) zur Nutzung des oben
                genannten Dienstes geschlossen. Hierbei handelt es sich um einen
                datenschutzrechtlich vorgeschriebenen Vertrag, der gew&auml;hrleistet, dass dieser
                die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und
                unter Einhaltung der DSGVO verarbeitet.
              </p>
              <h3>Newsletterversand an Bestandskunden</h3>{' '}
              <p>
                Wenn Sie Waren oder Dienstleistungen bei uns bestellen und hierbei Ihre
                E-Mail-Adresse hinterlegen, kann diese E-Mail-Adresse in der Folge durch uns
                f&uuml;r den Versand von Newslettern verwendet werden, sofern wir Sie vorab
                hier&uuml;ber informieren. In einem solchen Fall wird &uuml;ber den Newsletter nur
                Direktwerbung f&uuml;r eigene &auml;hnliche Waren oder Dienstleistungen versendet.
                Die Zusendung dieses Newsletters kann von Ihnen jederzeit gek&uuml;ndigt werden. Zu
                diesem Zweck findet sich in jedem Newsletter ein entsprechender Link.
                Rechtsgrundlage f&uuml;r den Versand des Newsletters ist in diesem Fall Art. 6 Abs.
                1 lit. f DSGVO in Verbindung mit &sect; 7 Abs. 3 UWG.
              </p>{' '}
              <p>
                Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre E-Mail-Adresse bei
                uns ggf. in einer Blacklist gespeichert, um k&uuml;nftige Mailings an Sie zu
                verhindern. Die Daten aus der Blacklist werden nur f&uuml;r diesen Zweck verwendet
                und nicht mit anderen Daten zusammengef&uuml;hrt. Dies dient sowohl Ihrem Interesse
                als auch unserem Interesse an der Einhaltung der gesetzlichen Vorgaben beim Versand
                von Newslettern (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f DSGVO).
                Die Speicherung in der Blacklist ist zeitlich nicht befristet. Sie k&ouml;nnen der
                Speicherung widersprechen, sofern Ihre Interessen unser berechtigtes Interesse
                &uuml;berwiegen.
              </p>
              <h2>6. Online-Marketing und Partner&shy;programme</h2>
              <h3>Affiliate-Programme auf dieser Website</h3>{' '}
              <p>
                Wir nehmen an Affiliate-Partnerprogrammen teil. Bei Affiliate-Partner-Programmen
                werden Werbeanzeigen eines Unternehmens auf Webseiten oder sonstigen Medien von
                anderen Unternehmen des Affiliate-Partner-Netzwerks platziert. Wenn Sie auf eine
                dieser Affiliate-Werbeanzeigen klicken, werden Sie zum beworbenen Angebot
                weitergeleitet. Sollten Sie anschlie&szlig;end eine bestimmte Transaktion
                (Conversion) t&auml;tigen, erh&auml;lt der Affiliate und ggf. der Inhaber des
                Mediums, auf dem die Werbung platziert hierf&uuml;r eine Verg&uuml;tung. Zur
                Berechnung dieser Verg&uuml;tung ist es erforderlich, dass der
                Affiliate-Netzwerkbetreiber nachvollziehen kann, &uuml;ber welche Werbeanzeige Sie
                auf das jeweilige Angebot gekommen sind und die vordefinierte Transaktion
                vorgenommen haben. Hierf&uuml;r werden Cookies oder vergleichbare
                Wiedererkennungstechnologien (z. B. Device-Fingerprinting) eingesetzt.
              </p>{' '}
              <p>
                Die Speicherung und Analyse der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
                DSGVO. Die Teilnehmer des Affiliate-Programms haben ein berechtigtes Interesse an
                der korrekten Berechnung der Affiliate-Verg&uuml;tung. Sofern eine entsprechende
                Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschlie&szlig;lich auf
                Grundlage von Art. 6 Abs. 1 lit. a DSGVO und &sect; 25 Abs. 1 TDDDG, soweit die
                Einwilligung die Speicherung von Cookies oder den Zugriff auf Informationen im
                Endger&auml;t des Nutzers (z.&nbsp;B. Device-Fingerprinting) im Sinne des TDDDG
                umfasst. Die Einwilligung ist jederzeit widerrufbar.
              </p>
              <p>Wir nehmen an folgenden Affiliate-Programmen teil:</p>
              <p>Rakuten Advertising - www.rakutenadvertising.com</p>
              <h2>7. eCommerce und Zahlungs&shy;anbieter</h2>
              <h3>Verarbeiten von Kunden- und Vertragsdaten</h3>{' '}
              <p>
                Wir erheben, verarbeiten und nutzen personenbezogene Kunden- und Vertragsdaten zur
                Begr&uuml;ndung, inhaltlichen Ausgestaltung und &Auml;nderung unserer
                Vertragsbeziehungen. Personenbezogene Daten &uuml;ber die Inanspruchnahme dieser
                Website (Nutzungsdaten) erheben, verarbeiten und nutzen wir nur, soweit dies
                erforderlich ist, um dem Nutzer die Inanspruchnahme des Dienstes zu erm&ouml;glichen
                oder abzurechnen. Rechtsgrundlage hierf&uuml;r ist Art. 6 Abs. 1 lit. b DSGVO.
              </p>{' '}
              <p>
                Die erhobenen Kundendaten werden nach Abschluss des Auftrags oder Beendigung der
                Gesch&auml;ftsbeziehung und Ablauf der ggf. bestehenden gesetzlichen
                Aufbewahrungsfristen gel&ouml;scht. Gesetzliche Aufbewahrungsfristen bleiben
                unber&uuml;hrt.
              </p>
              <h3>
                Daten&shy;&uuml;bermittlung bei Vertragsschluss f&uuml;r Online-Shops, H&auml;ndler
                und Warenversand
              </h3>{' '}
              <p>
                Wenn Sie Waren bei uns bestellen, geben wir Ihre personenbezogenen Daten an das zur
                Lieferung betraute Transportunternehmen sowie an den mit der Zahlungsabwicklung
                beauftragten Zahlungsdienstleister weiter. Es werden nur solche Daten herausgegeben,
                die der jeweilige Dienstleister zur Erf&uuml;llung seiner Aufgabe ben&ouml;tigt.
                Rechtsgrundlage hierf&uuml;r ist Art. 6 Abs. 1 lit. b DSGVO, der die Verarbeitung
                von Daten zur Erf&uuml;llung eines Vertrags oder vorvertraglicher Ma&szlig;nahmen
                gestattet. Sofern Sie eine entsprechende Einwilligung nach Art. 6 Abs. 1 lit. a
                DSGVO erteilt haben, werden wir Ihre E-Mail-Adresse an das mit der Lieferung
                betraute Transportunternehmen &uuml;bergeben, damit dieses Sie per E-Mail &uuml;ber
                den Versandstatus Ihrer Bestellung informieren kann; Sie k&ouml;nnen die
                Einwilligung jederzeit widerrufen.
              </p>
              <h3>
                Daten&shy;&uuml;bermittlung bei Vertragsschluss f&uuml;r Dienstleistungen und
                digitale Inhalte
              </h3>{' '}
              <p>
                Wir &uuml;bermitteln personenbezogene Daten an Dritte nur dann, wenn dies im Rahmen
                der Vertragsabwicklung notwendig ist, etwa an das mit der Zahlungsabwicklung
                beauftragte Kreditinstitut.
              </p>{' '}
              <p>
                Eine weitergehende &Uuml;bermittlung der Daten erfolgt nicht bzw. nur dann, wenn Sie
                der &Uuml;bermittlung ausdr&uuml;cklich zugestimmt haben. Eine Weitergabe Ihrer
                Daten an Dritte ohne ausdr&uuml;ckliche Einwilligung, etwa zu Zwecken der Werbung,
                erfolgt nicht.
              </p>{' '}
              <p>
                Grundlage f&uuml;r die Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, der die
                Verarbeitung von Daten zur Erf&uuml;llung eines Vertrags oder vorvertraglicher
                Ma&szlig;nahmen gestattet.
              </p>
              <h3>Zahlungsdienste</h3>{' '}
              <p>
                Wir binden Zahlungsdienste von Drittunternehmen auf unserer Website ein. Wenn Sie
                einen Kauf bei uns t&auml;tigen, werden Ihre Zahlungsdaten (z.&nbsp;B. Name,
                Zahlungssumme, Kontoverbindung, Kreditkartennummer) vom Zahlungsdienstleister zum
                Zwecke der Zahlungsabwicklung verarbeitet. F&uuml;r diese Transaktionen gelten die
                jeweiligen Vertrags- und Datenschutzbestimmungen der jeweiligen Anbieter. Der
                Einsatz der Zahlungsdienstleister erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b
                DSGVO (Vertragsabwicklung) sowie im Interesse eines m&ouml;glichst reibungslosen,
                komfortablen und sicheren Zahlungsvorgangs (Art. 6 Abs. 1 lit. f DSGVO). Soweit
                f&uuml;r bestimmte Handlungen Ihre Einwilligung abgefragt wird, ist Art. 6 Abs. 1
                lit. a DSGVO Rechtsgrundlage der Datenverarbeitung; Einwilligungen sind jederzeit
                f&uuml;r die Zukunft widerrufbar.
              </p>
              <p>
                Folgende Zahlungsdienste / Zahlungsdienstleister setzen wir im Rahmen dieser Website
                ein:
              </p>
              <h4>PayPal</h4>{' '}
              <p>
                Anbieter dieses Zahlungsdienstes ist PayPal (Europe) S.&agrave;.r.l. et Cie, S.C.A.,
                22-24 Boulevard Royal, L-2449 Luxembourg (im Folgenden &bdquo;PayPal&ldquo;).
              </p>{' '}
              <p>
                Die Daten&uuml;bertragung in die USA wird auf die Standardvertragsklauseln der
                EU-Kommission gest&uuml;tzt. Details finden Sie hier:{' '}
                <a
                  href="https://www.paypal.com/de/webapps/mpp/ua/pocpsa-full"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.paypal.com/de/webapps/mpp/ua/pocpsa-full
                </a>
                .
              </p>{' '}
              <p>
                Details entnehmen Sie der Datenschutzerkl&auml;rung von PayPal:{' '}
                <a
                  href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.paypal.com/de/webapps/mpp/ua/privacy-full
                </a>
                .
              </p>
              <h4>Stripe</h4>{' '}
              <p>
                Anbieter f&uuml;r Kunden innerhalb der EU ist die Stripe Payments Europe, Ltd.,1
                Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland (im Folgenden
                &bdquo;Stripe&ldquo;).
              </p>{' '}
              <p>
                Die Daten&uuml;bertragung in die USA wird auf die Standardvertragsklauseln der
                EU-Kommission gest&uuml;tzt. Details finden Sie hier:{' '}
                <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">
                  https://stripe.com/de/privacy
                </a>{' '}
                und{' '}
                <a
                  href="https://stripe.com/de/guides/general-data-protection-regulation"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://stripe.com/de/guides/general-data-protection-regulation
                </a>
                .
              </p>{' '}
              <p>
                Details hierzu k&ouml;nnen Sie in der Datenschutzerkl&auml;rung von Stripe unter
                folgendem Link nachlesen:{' '}
                <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">
                  https://stripe.com/de/privacy
                </a>
                .
              </p>
              <h2>8. Audio- und Videokonferenzen</h2>
              <h4>Datenverarbeitung</h4>{' '}
              <p>
                F&uuml;r die Kommunikation mit unseren Kunden setzen wir unter anderen
                Online-Konferenz-Tools ein. Die im Einzelnen von uns genutzten Tools sind unten
                aufgelistet. Wenn Sie mit uns per Video- oder Audiokonferenz via Internet
                kommunizieren, werden Ihre personenbezogenen Daten von uns und dem Anbieter des
                jeweiligen Konferenz-Tools erfasst und verarbeitet.
              </p>{' '}
              <p>
                Die Konferenz-Tools erfassen dabei alle Daten, die Sie zur Nutzung der Tools
                bereitstellen/einsetzen (E-Mail-Adresse und/oder Ihre Telefonnummer). Ferner
                verarbeiten die Konferenz-Tools die Dauer der Konferenz, Beginn und Ende (Zeit) der
                Teilnahme an der Konferenz, Anzahl der Teilnehmer und sonstige
                &bdquo;Kontextinformationen&ldquo; im Zusammenhang mit dem Kommunikationsvorgang
                (Metadaten).
              </p>{' '}
              <p>
                Des Weiteren verarbeitet der Anbieter des Tools alle technischen Daten, die zur
                Abwicklung der Online-Kommunikation erforderlich sind. Dies umfasst insbesondere
                IP-Adressen, MAC-Adressen, Ger&auml;te-IDs, Ger&auml;tetyp, Betriebssystemtyp und
                -version, Client-Version, Kameratyp, Mikrofon oder Lautsprecher sowie die Art der
                Verbindung.
              </p>{' '}
              <p>
                Sofern innerhalb des Tools Inhalte ausgetauscht, hochgeladen oder in sonstiger Weise
                bereitgestellt werden, werden diese ebenfalls auf den Servern der Tool-Anbieter
                gespeichert. Zu solchen Inhalten z&auml;hlen insbesondere Cloud-Aufzeichnungen,
                Chat-/ Sofortnachrichten, Voicemails hochgeladene Fotos und Videos, Dateien,
                Whiteboards und andere Informationen, die w&auml;hrend der Nutzung des Dienstes
                geteilt werden.
              </p>{' '}
              <p>
                Bitte beachten Sie, dass wir nicht vollumf&auml;nglich Einfluss auf die
                Datenverarbeitungsvorg&auml;nge der verwendeten Tools haben. Unsere
                M&ouml;glichkeiten richten sich ma&szlig;geblich nach der Unternehmenspolitik des
                jeweiligen Anbieters. Weitere Hinweise zur Datenverarbeitung durch die
                Konferenztools entnehmen Sie den Datenschutzerkl&auml;rungen der jeweils
                eingesetzten Tools, die wir unter diesem Text aufgef&uuml;hrt haben.
              </p>{' '}
              <h4>Zweck und Rechtsgrundlagen</h4>{' '}
              <p>
                Die Konferenz-Tools werden genutzt, um mit angehenden oder bestehenden
                Vertragspartnern zu kommunizieren oder bestimmte Leistungen gegen&uuml;ber unseren
                Kunden anzubieten (Art. 6 Abs. 1 lit. b DSGVO). Des Weiteren dient der Einsatz der
                Tools der allgemeinen Vereinfachung und Beschleunigung der Kommunikation mit uns
                bzw. unserem Unternehmen (berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f
                DSGVO). Soweit eine Einwilligung abgefragt wurde, erfolgt der Einsatz der
                betreffenden Tools auf Grundlage dieser Einwilligung; die Einwilligung ist jederzeit
                mit Wirkung f&uuml;r die Zukunft widerrufbar.
              </p>{' '}
              <h4>Speicherdauer</h4>{' '}
              <p>
                Die unmittelbar von uns &uuml;ber die Video- und Konferenz-Tools erfassten Daten
                werden von unseren Systemen gel&ouml;scht, sobald Sie uns zur L&ouml;schung
                auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck f&uuml;r die
                Datenspeicherung entf&auml;llt. Gespeicherte Cookies verbleiben auf Ihrem
                Endger&auml;t, bis Sie sie l&ouml;schen. Zwingende gesetzliche Aufbewahrungsfristen
                bleiben unber&uuml;hrt.
              </p>{' '}
              <p>
                Auf die Speicherdauer Ihrer Daten, die von den Betreibern der Konferenz-Tools zu
                eigenen Zwecken gespeichert werden, haben wir keinen Einfluss. F&uuml;r Einzelheiten
                dazu informieren Sie sich bitte direkt bei den Betreibern der Konferenz-Tools.
              </p>{' '}
              <h4>Eingesetzte Konferenz-Tools</h4> <p>Wir setzen folgende Konferenz-Tools ein:</p>
              <h3>Microsoft Teams</h3>{' '}
              <p>
                Wir nutzen Microsoft Teams. Anbieter ist die Microsoft Ireland Operations Limited,
                One Microsoft Place, South County Business Park, Leopardstown, Dublin 18, Irland.
                Details zur Datenverarbeitung entnehmen Sie der Datenschutzerkl&auml;rung von
                Microsoft Teams:{' '}
                <a
                  href="https://privacy.microsoft.com/de-de/privacystatement"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://privacy.microsoft.com/de-de/privacystatement
                </a>
                .
              </p>
              <p>
                Das Unternehmen verf&uuml;gt &uuml;ber eine Zertifizierung nach dem &bdquo;EU-US
                Data Privacy Framework&ldquo; (DPF). Der DPF ist ein &Uuml;bereinkommen zwischen der
                Europ&auml;ischen Union und den USA, der die Einhaltung europ&auml;ischer
                Datenschutzstandards bei Datenverarbeitungen in den USA gew&auml;hrleisten soll.
                Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich, diese
                Datenschutzstandards einzuhalten. Weitere Informationen hierzu erhalten Sie vom
                Anbieter unter folgendem Link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/6474"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/6474
                </a>
                .
              </p>
              <h4>Auftragsverarbeitung</h4>{' '}
              <p>
                Wir haben einen Vertrag &uuml;ber Auftragsverarbeitung (AVV) zur Nutzung des oben
                genannten Dienstes geschlossen. Hierbei handelt es sich um einen
                datenschutzrechtlich vorgeschriebenen Vertrag, der gew&auml;hrleistet, dass dieser
                die personenbezogenen Daten unserer Websitebesucher nur nach unseren Weisungen und
                unter Einhaltung der DSGVO verarbeitet.
              </p>
            </div>
          </div>
        </DIV>

        <DIV language="en">
          <div className="page-content bg-top2">
            <div className="inner-content">
              <h1>Privacy Policy</h1>
            </div>
          </div>
          <div className="page-content bg-1">
            <div className="inner-content">
              <h1>Privacy Policy</h1>
              <h2>1. An overview of data protection</h2>
              <h3>General information</h3>{' '}
              <p>
                The following information will provide you with an easy to navigate overview of what
                will happen with your personal data when you visit this website. The term
                &ldquo;personal data&rdquo; comprises all data that can be used to personally
                identify you. For detailed information about the subject matter of data protection,
                please consult our Data Protection Declaration, which we have included beneath this
                copy.
              </p>
              <h3>Data recording on this website</h3>{' '}
              <h4>
                Who is the responsible party for the recording of data on this website (i.e., the
                &ldquo;controller&rdquo;)?
              </h4>{' '}
              <p>
                The data on this website is processed by the operator of the website, whose contact
                information is available under section &ldquo;Information about the responsible
                party (referred to as the &ldquo;controller&rdquo; in the GDPR)&rdquo; in this
                Privacy Policy.
              </p>{' '}
              <h4>How do we record your data?</h4>{' '}
              <p>
                We collect your data as a result of your sharing of your data with us. This may, for
                instance be information you enter into our contact form.
              </p>{' '}
              <p>
                Other data shall be recorded by our IT systems automatically or after you consent to
                its recording during your website visit. This data comprises primarily technical
                information (e.g., web browser, operating system, or time the site was accessed).
                This information is recorded automatically when you access this website.
              </p>{' '}
              <h4>What are the purposes we use your data for?</h4>{' '}
              <p>
                A portion of the information is generated to guarantee the error free provision of
                the website. Other data may be used to analyze your user patterns. If contracts can
                be concluded or initiated via the website, the transmitted data will also be
                processed for contract offers, orders or other order enquiries.
              </p>{' '}
              <h4>What rights do you have as far as your information is concerned?</h4>{' '}
              <p>
                You have the right to receive information about the source, recipients, and purposes
                of your archived personal data at any time without having to pay a fee for such
                disclosures. You also have the right to demand that your data are rectified or
                eradicated. If you have consented to data processing, you have the option to revoke
                this consent at any time, which shall affect all future data processing. Moreover,
                you have the right to demand that the processing of your data be restricted under
                certain circumstances. Furthermore, you have the right to log a complaint with the
                competent supervising agency.
              </p>{' '}
              <p>
                Please do not hesitate to contact us at any time if you have questions about this or
                any other data protection related issues.
              </p>
              <h3>Analysis tools and tools provided by third parties</h3>{' '}
              <p>
                There is a possibility that your browsing patterns will be statistically analyzed
                when your visit this website. Such analyses are performed primarily with what we
                refer to as analysis programs.
              </p>{' '}
              <p>
                For detailed information about these analysis programs please consult our Data
                Protection Declaration below.
              </p>
              <h2>2. General information and mandatory information</h2>
              <h3>Data protection</h3>{' '}
              <p>
                The operators of this website and its pages take the protection of your personal
                data very seriously. Hence, we handle your personal data as confidential information
                and in compliance with the statutory data protection regulations and this Data
                Protection Declaration.
              </p>{' '}
              <p>
                Whenever you use this website, a variety of personal information will be collected.
                Personal data comprises data that can be used to personally identify you. This Data
                Protection Declaration explains which data we collect as well as the purposes we use
                this data for. It also explains how, and for which purpose the information is
                collected.
              </p>{' '}
              <p>
                We herewith advise you that the transmission of data via the Internet (i.e., through
                e-mail communications) may be prone to security gaps. It is not possible to
                completely protect data against third-party access.
              </p>
              <h3>
                Information about the responsible party (referred to as the &ldquo;controller&rdquo;
                in the GDPR)
              </h3>{' '}
              <p>The data processing controller on this website is:</p>{' '}
              <p>
                2x4 Solutions GmbH
                <br />
                Fichtenring 8<br />
                84562 Mettenheim
                <br />
                Deutschland
              </p>
              <p>
                Phone: +49 8631 607164
                <br />
                E-mail: info@2x4.de
              </p>
              <p>
                The controller is the natural person or legal entity that single-handedly or jointly
                with others makes decisions as to the purposes of and resources for the processing
                of personal data (e.g., names, e-mail addresses, etc.).
              </p>
              <h3>Storage duration</h3>{' '}
              <p>
                Unless a more specific storage period has been specified in this privacy policy,
                your personal data will remain with us until the purpose for which it was collected
                no longer applies. If you assert a justified request for deletion or revoke your
                consent to data processing, your data will be deleted, unless we have other legally
                permissible reasons for storing your personal data (e.g., tax or commercial law
                retention periods); in the latter case, the deletion will take place after these
                reasons cease to apply.
              </p>
              <h3>
                General information on the legal basis for the data processing on this website
              </h3>{' '}
              <p>
                If you have consented to data processing, we process your personal data on the basis
                of Art. 6(1)(a) GDPR or Art. 9 (2)(a) GDPR, if special categories of data are
                processed according to Art. 9 (1) DSGVO. In the case of explicit consent to the
                transfer of personal data to third countries, the data processing is also based on
                Art. 49 (1)(a) GDPR. If you have consented to the storage of cookies or to the
                access to information in your end device (e.g., via device fingerprinting), the data
                processing is additionally based on &sect; 25 (1) TDDDG. The consent can be revoked
                at any time. If your data is required for the fulfillment of a contract or for the
                implementation of pre-contractual measures, we process your data on the basis of
                Art. 6(1)(b) GDPR. Furthermore, if your data is required for the fulfillment of a
                legal obligation, we process it on the basis of Art. 6(1)(c) GDPR. Furthermore, the
                data processing may be carried out on the basis of our legitimate interest according
                to Art. 6(1)(f) GDPR. Information on the relevant legal basis in each individual
                case is provided in the following paragraphs of this privacy policy.
              </p>
              <h3>Recipients of personal data</h3>{' '}
              <p>
                In the scope of our business activities, we cooperate with various external parties.
                In some cases, this also requires the transfer of personal data to these external
                parties. We only disclose personal data to external parties if this is required as
                part of the fulfillment of a contract, if we are legally obligated to do so (e.g.,
                disclosure of data to tax authorities), if we have a legitimate interest in the
                disclosure pursuant to Art. 6 (1)(f) GDPR, or if another legal basis permits the
                disclosure of this data. When using processors, we only disclose personal data of
                our customers on the basis of a valid contract on data processing. In the case of
                joint processing, a joint processing agreement is concluded.
              </p>
              <h3>Revocation of your consent to the processing of data</h3>{' '}
              <p>
                A wide range of data processing transactions are possible only subject to your
                express consent. You can also revoke at any time any consent you have already given
                us. This shall be without prejudice to the lawfulness of any data collection that
                occurred prior to your revocation.
              </p>
              <h3>
                Right to object to the collection of data in special cases; right to object to
                direct advertising (Art. 21 GDPR)
              </h3>{' '}
              <p>
                IN THE EVENT THAT DATA ARE PROCESSED ON THE BASIS OF ART. 6(1)(E) OR (F) GDPR, YOU
                HAVE THE RIGHT TO AT ANY TIME OBJECT TO THE PROCESSING OF YOUR PERSONAL DATA BASED
                ON GROUNDS ARISING FROM YOUR UNIQUE SITUATION. THIS ALSO APPLIES TO ANY PROFILING
                BASED ON THESE PROVISIONS. TO DETERMINE THE LEGAL BASIS, ON WHICH ANY PROCESSING OF
                DATA IS BASED, PLEASE CONSULT THIS DATA PROTECTION DECLARATION. IF YOU LOG AN
                OBJECTION, WE WILL NO LONGER PROCESS YOUR AFFECTED PERSONAL DATA, UNLESS WE ARE IN A
                POSITION TO PRESENT COMPELLING PROTECTION WORTHY GROUNDS FOR THE PROCESSING OF YOUR
                DATA, THAT OUTWEIGH YOUR INTERESTS, RIGHTS AND FREEDOMS OR IF THE PURPOSE OF THE
                PROCESSING IS THE CLAIMING, EXERCISING OR DEFENCE OF LEGAL ENTITLEMENTS (OBJECTION
                PURSUANT TO ART. 21(1) GDPR).
              </p>{' '}
              <p>
                IF YOUR PERSONAL DATA IS BEING PROCESSED IN ORDER TO ENGAGE IN DIRECT ADVERTISING,
                YOU HAVE THE RIGHT TO OBJECT TO THE PROCESSING OF YOUR AFFECTED PERSONAL DATA FOR
                THE PURPOSES OF SUCH ADVERTISING AT ANY TIME. THIS ALSO APPLIES TO PROFILING TO THE
                EXTENT THAT IT IS AFFILIATED WITH SUCH DIRECT ADVERTISING. IF YOU OBJECT, YOUR
                PERSONAL DATA WILL SUBSEQUENTLY NO LONGER BE USED FOR DIRECT ADVERTISING PURPOSES
                (OBJECTION PURSUANT TO ART. 21(2) GDPR).
              </p>
              <h3>Right to log a complaint with the competent supervisory agency</h3>{' '}
              <p>
                In the event of violations of the GDPR, data subjects are entitled to log a
                complaint with a supervisory agency, in particular in the member state where they
                usually maintain their domicile, place of work or at the place where the alleged
                violation occurred. The right to log a complaint is in effect regardless of any
                other administrative or court proceedings available as legal recourses.
              </p>
              <h3>Right to data portability</h3>{' '}
              <p>
                You have the right to have data that we process automatically on the basis of your
                consent or in fulfillment of a contract handed over to you or to a third party in a
                common, machine-readable format. If you should demand the direct transfer of the
                data to another controller, this will be done only if it is technically feasible.
              </p>
              <h3>Information about, rectification and eradication of data</h3>{' '}
              <p>
                Within the scope of the applicable statutory provisions, you have the right to
                demand information about your archived personal data, their source and recipients as
                well as the purpose of the processing of your data at any time. You may also have a
                right to have your data rectified or eradicated. If you have questions about this
                subject matter or any other questions about personal data, please do not hesitate to
                contact us at any time.
              </p>
              <h3>Right to demand processing restrictions</h3>{' '}
              <p>
                You have the right to demand the imposition of restrictions as far as the processing
                of your personal data is concerned. To do so, you may contact us at any time. The
                right to demand restriction of processing applies in the following cases:
              </p>{' '}
              <ul>
                {' '}
                <li>
                  In the event that you should dispute the correctness of your data archived by us,
                  we will usually need some time to verify this claim. During the time that this
                  investigation is ongoing, you have the right to demand that we restrict the
                  processing of your personal data.
                </li>{' '}
                <li>
                  If the processing of your personal data was/is conducted in an unlawful manner,
                  you have the option to demand the restriction of the processing of your data
                  instead of demanding the eradication of this data.
                </li>{' '}
                <li>
                  If we do not need your personal data any longer and you need it to exercise,
                  defend or claim legal entitlements, you have the right to demand the restriction
                  of the processing of your personal data instead of its eradication.
                </li>{' '}
                <li>
                  If you have raised an objection pursuant to Art. 21(1) GDPR, your rights and our
                  rights will have to be weighed against each other. As long as it has not been
                  determined whose interests prevail, you have the right to demand a restriction of
                  the processing of your personal data.
                </li>{' '}
              </ul>{' '}
              <p>
                If you have restricted the processing of your personal data, these data &ndash; with
                the exception of their archiving &ndash; may be processed only subject to your
                consent or to claim, exercise or defend legal entitlements or to protect the rights
                of other natural persons or legal entities or for important public interest reasons
                cited by the European Union or a member state of the EU.
              </p>
              <h3>SSL and/or TLS encryption</h3>{' '}
              <p>
                For security reasons and to protect the transmission of confidential content, such
                as purchase orders or inquiries you submit to us as the website operator, this
                website uses either an SSL or a TLS encryption program. You can recognize an
                encrypted connection by checking whether the address line of the browser switches
                from &ldquo;http://&rdquo; to &ldquo;https://&rdquo; and also by the appearance of
                the lock icon in the browser line.
              </p>{' '}
              <p>
                If the SSL or TLS encryption is activated, data you transmit to us cannot be read by
                third parties.
              </p>
              <h3>Encrypted payment transactions on this website</h3>{' '}
              <p>
                If you are under an obligation to share your payment information (e.g. account
                number if you give us the authority to debit your bank account) with us after you
                have entered into a fee-based contract with us, this information is required to
                process payments.
              </p>{' '}
              <p>
                Payment transactions using common modes of paying (Visa/MasterCard, debit to your
                bank account) are processed exclusively via encrypted SSL or TLS connections. You
                can recognize an encrypted connection by checking whether the address line of the
                browser switches from &ldquo;http://&rdquo; to &ldquo;https://&rdquo; and also by
                the appearance of the lock icon in the browser line.
              </p>{' '}
              <p>
                If the communication with us is encrypted, third parties will not be able to read
                the payment information you share with us.
              </p>
              <h3>Rejection of unsolicited e-mails</h3>{' '}
              <p>
                We herewith object to the use of contact information published in conjunction with
                the mandatory information to be provided in our Site Notice to send us promotional
                and information material that we have not expressly requested. The operators of this
                website and its pages reserve the express right to take legal action in the event of
                the unsolicited sending of promotional information, for instance via SPAM messages.
              </p>
              <h2>3. Recording of data on this website</h2>
              <h3>Cookies</h3>{' '}
              <p>
                Our websites and pages use what the industry refers to as &ldquo;cookies.&rdquo;
                Cookies are small data packages that do not cause any damage to your device. They
                are either stored temporarily for the duration of a session (session cookies) or
                they are permanently archived on your device (permanent cookies). Session cookies
                are automatically deleted once you terminate your visit. Permanent cookies remain
                archived on your device until you actively delete them, or they are automatically
                eradicated by your web browser.
              </p>{' '}
              <p>
                Cookies can be issued by us (first-party cookies) or by third-party companies
                (so-called third-party cookies). Third-party cookies enable the integration of
                certain services of third-party companies into websites (e.g., cookies for handling
                payment services).
              </p>{' '}
              <p>
                Cookies have a variety of functions. Many cookies are technically essential since
                certain website functions would not work in the absence of these cookies (e.g., the
                shopping cart function or the display of videos). Other cookies may be used to
                analyze user behavior or for promotional purposes.
              </p>{' '}
              <p>
                Cookies, which are required for the performance of electronic communication
                transactions, for the provision of certain functions you want to use (e.g., for the
                shopping cart function) or those that are necessary for the optimization (required
                cookies) of the website (e.g., cookies that provide measurable insights into the web
                audience), shall be stored on the basis of Art. 6(1)(f) GDPR, unless a different
                legal basis is cited. The operator of the website has a legitimate interest in the
                storage of required cookies to ensure the technically error-free and optimized
                provision of the operator&rsquo;s services. If your consent to the storage of the
                cookies and similar recognition technologies has been requested, the processing
                occurs exclusively on the basis of the consent obtained (Art. 6(1)(a) GDPR and
                &sect; 25 (1) TDDDG); this consent may be revoked at any time.
              </p>{' '}
              <p>
                You have the option to set up your browser in such a manner that you will be
                notified any time cookies are placed and to permit the acceptance of cookies only in
                specific cases. You may also exclude the acceptance of cookies in certain cases or
                in general or activate the delete-function for the automatic eradication of cookies
                when the browser closes. If cookies are deactivated, the functions of this website
                may be limited.
              </p>{' '}
              <p>
                Which cookies and services are used on this website can be found in this privacy
                policy.
              </p>
              <h3>Server log files</h3>{' '}
              <p>
                The provider of this website and its pages automatically collects and stores
                information in so-called server log files, which your browser communicates to us
                automatically. The information comprises:
              </p>{' '}
              <ul>
                {' '}
                <li>The type and version of browser used</li> <li>The used operating system</li>{' '}
                <li>Referrer URL</li> <li>The hostname of the accessing computer</li>{' '}
                <li>The time of the server inquiry</li> <li>The IP address</li>{' '}
              </ul>{' '}
              <p>This data is not merged with other data sources.</p>{' '}
              <p>
                This data is recorded on the basis of Art. 6(1)(f) GDPR. The operator of the website
                has a legitimate interest in the technically error free depiction and the
                optimization of the operator&rsquo;s website. In order to achieve this, server log
                files must be recorded.
              </p>
              <h3>Contact form</h3>{' '}
              <p>
                If you submit inquiries to us via our contact form, the information provided in the
                contact form as well as any contact information provided therein will be stored by
                us in order to handle your inquiry and in the event that we have further questions.
                We will not share this information without your consent.
              </p>{' '}
              <p>
                The processing of these data is based on Art. 6(1)(b) GDPR, if your request is
                related to the execution of a contract or if it is necessary to carry out
                pre-contractual measures. In all other cases the processing is based on our
                legitimate interest in the effective processing of the requests addressed to us
                (Art. 6(1)(f) GDPR) or on your agreement (Art. 6(1)(a) GDPR) if this has been
                requested; the consent can be revoked at any time.
              </p>{' '}
              <p>
                The information you have entered into the contact form shall remain with us until
                you ask us to eradicate the data, revoke your consent to the archiving of data or if
                the purpose for which the information is being archived no longer exists (e.g.,
                after we have concluded our response to your inquiry). This shall be without
                prejudice to any mandatory legal provisions, in particular retention periods.
              </p>
              <h3>Request by e-mail, telephone, or fax</h3>{' '}
              <p>
                If you contact us by e-mail, telephone or fax, your request, including all resulting
                personal data (name, request) will be stored and processed by us for the purpose of
                processing your request. We do not pass these data on without your consent.
              </p>{' '}
              <p>
                These data are processed on the basis of Art. 6(1)(b) GDPR if your inquiry is
                related to the fulfillment of a contract or is required for the performance of
                pre-contractual measures. In all other cases, the data are processed on the basis of
                our legitimate interest in the effective handling of inquiries submitted to us (Art.
                6(1)(f) GDPR) or on the basis of your consent (Art. 6(1)(a) GDPR) if it has been
                obtained; the consent can be revoked at any time.
              </p>{' '}
              <p>
                The data sent by you to us via contact requests remain with us until you request us
                to delete, revoke your consent to the storage or the purpose for the data storage
                lapses (e.g. after completion of your request). Mandatory statutory provisions - in
                particular statutory retention periods - remain unaffected.
              </p>
              <h3>Registration on this website</h3>{' '}
              <p>
                You have the option to register on this website to be able to use additional website
                functions. We shall use the data you enter only for the purpose of using the
                respective offer or service you have registered for. The required information we
                request at the time of registration must be entered in full. Otherwise, we shall
                reject the registration.
              </p>{' '}
              <p>
                To notify you of any important changes to the scope of our portfolio or in the event
                of technical modifications, we shall use the e-mail address provided during the
                registration process.
              </p>{' '}
              <p>
                We shall process the data entered during the registration process on the basis of
                your consent (Art. 6(1)(a) GDPR).
              </p>{' '}
              <p>
                The data recorded during the registration process shall be stored by us as long as
                you are registered on this website. Subsequently, such data shall be deleted. This
                shall be without prejudice to mandatory statutory retention obligations.
              </p>
              <h3>The comment function on this website</h3>{' '}
              <p>
                When you use the comment function on this website, information on the time the
                comment was generated and your e-mail-address and, if you are not posting
                anonymously, the username you have selected will be archived in addition to your
                comments.
              </p>
              <h4>Storage of the IP address</h4>{' '}
              <p>
                Our comment function stores the IP addresses of all users who enter comments. Given
                that we do not review the comments prior to publishing them, we need this
                information in order to take action against the author in the event of rights
                violations, such as defamation or propaganda.
              </p>
              <h4>Subscribing to comments</h4>{' '}
              <p>
                As a user of this website, you have the option to subscribe to comments after you
                have registered. You will receive a confirmation e-mail, the purpose of which is to
                verify whether you are the actual holder of the provided e-mail address. You can
                deactivate this function at any time by following a respective link in the
                information e-mails. The data entered in conjunction with subscriptions to comments
                will be deleted in this case. However, if you have communicated this information to
                us for other purposes and from a different location (e.g., when subscribing to the
                newsletter), the data shall remain in our possession.
              </p>
              <h4>Storage period for comments</h4>{' '}
              <p>
                Comments and any affiliated information shall be stored by us and remain on this
                website until the content the comment pertained to has been deleted in its entirety
                or if the comments had to be deleted for legal reasons (e.g., insulting comments).
              </p>
              <h4>Legal basis</h4>{' '}
              <p>
                Comments are stored on the basis of your consent (Art. 6(1)(a) GDPR). You have the
                right to revoke at any time any consent you have already given us. To do so, all you
                are required to do is sent us an informal notification via e-mail. This shall be
                without prejudice to the lawfulness of any data collection that occurred prior to
                your revocation.
              </p>
              <h2>4. Analysis tools and advertising</h2>
              <h3>Google Analytics</h3>{' '}
              <p>
                This website uses functions of the web analysis service Google Analytics. The
                provider of this service is Google Ireland Limited (&ldquo;Google&rdquo;), Gordon
                House, Barrow Street, Dublin 4, Ireland.
              </p>{' '}
              <p>
                Google Analytics enables the website operator to analyze the behavior patterns of
                website visitors. To that end, the website operator receives a variety of user data,
                such as pages accessed, time spent on the page, the utilized operating system and
                the user&rsquo;s origin. This data is assigned to the respective end device of the
                user. An assignment to a user-ID does not take place.
              </p>{' '}
              <p>
                Furthermore, Google Analytics allows us to record your mouse and scroll movements
                and clicks, among other things. Google Analytics uses various modeling approaches to
                augment the collected data sets and uses machine learning technologies in data
                analysis.
              </p>
              <p>
                Google Analytics uses technologies that make the recognition of the user for the
                purpose of analyzing the user behavior patterns (e.g., cookies or device
                fingerprinting). The website use information recorded by Google is, as a rule
                transferred to a Google server in the United States, where it is stored.
              </p>{' '}
              <p>
                The use of these services occurs on the basis of your consent pursuant to Art.
                6(1)(a) GDPR and &sect; 25(1) TDDDG. You may revoke your consent at any time.
              </p>{' '}
              <p>
                Data transmission to the US is based on the Standard Contractual Clauses (SCC) of
                the European Commission. Details can be found here:{' '}
                <a
                  href="https://privacy.google.com/businesses/controllerterms/mccs/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://privacy.google.com/businesses/controllerterms/mccs/
                </a>
                .
              </p>{' '}
              <p>
                The company is certified in accordance with the &ldquo;EU-US Data Privacy
                Framework&rdquo; (DPF). The DPF is an agreement between the European Union and the
                US, which is intended to ensure compliance with European data protection standards
                for data processing in the US. Every company certified under the DPF is obliged to
                comply with these data protection standards. For more information, please contact
                the provider under the following link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/5780"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/5780
                </a>
                .
              </p>
              <h4>IP anonymization</h4>{' '}
              <p>
                Google Analytics IP anonymization is active. As a result, your IP address will be
                abbreviated by Google within the member states of the European Union or in other
                states that have ratified the Convention on the European Economic Area prior to its
                transmission to the United States. The full IP address will be transmitted to one of
                Google&rsquo;s servers in the United States and abbreviated there only in
                exceptional cases. On behalf of the operator of this website, Google shall use this
                information to analyze your use of this website to generate reports on website
                activities and to render other services to the operator of this website that are
                related to the use of the website and the Internet. The IP address transmitted in
                conjunction with Google Analytics from your browser shall not be merged with other
                data in Google&rsquo;s possession.
              </p>
              <h4>Browser plug-in</h4>{' '}
              <p>
                You can prevent the recording and processing of your data by Google by downloading
                and installing the browser plugin available under the following link:{' '}
                <a
                  href="https://tools.google.com/dlpage/gaoptout?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://tools.google.com/dlpage/gaoptout?hl=en
                </a>
                .
              </p>{' '}
              <p>
                For more information about the handling of user data by Google Analytics, please
                consult Google&rsquo;s Data Privacy Declaration at:{' '}
                <a
                  href="https://support.google.com/analytics/answer/6004245?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://support.google.com/analytics/answer/6004245?hl=en
                </a>
                .
              </p>
              <h4>Contract data processing</h4>{' '}
              <p>
                We have executed a contract data processing agreement with Google and are
                implementing the stringent provisions of the German data protection agencies to the
                fullest when using Google Analytics.
              </p>
              <h3>Google Ads</h3>{' '}
              <p>
                The website operator uses Google Ads. Google Ads is an online promotional program of
                Google Ireland Limited (&ldquo;Google&rdquo;), Gordon House, Barrow Street, Dublin
                4, Ireland.
              </p>{' '}
              <p>
                Google Ads enables us to display ads in the Google search engine or on third-party
                websites, if the user enters certain search terms into Google (keyword targeting).
                It is also possible to place targeted ads based on the user data Google has in its
                possession (e.g., location data and interests; target group targeting). As the
                website operator, we can analyze these data quantitatively, for instance by
                analyzing which search terms resulted in the display of our ads and how many ads led
                to respective clicks.
              </p>{' '}
              <p>
                The use of these services occurs on the basis of your consent pursuant to Art.
                6(1)(a) GDPR and &sect; 25(1) TDDDG. You may revoke your consent at any time.
              </p>{' '}
              <p>
                Data transmission to the US is based on the Standard Contractual Clauses (SCC) of
                the European Commission. Details can be found here:{' '}
                <a
                  href="https://policies.google.com/privacy/frameworks"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://policies.google.com/privacy/frameworks
                </a>{' '}
                and{' '}
                <a
                  href="https://business.safety.google/controllerterms/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://business.safety.google/controllerterms/
                </a>
                .
              </p>
              <p>
                The company is certified in accordance with the &ldquo;EU-US Data Privacy
                Framework&rdquo; (DPF). The DPF is an agreement between the European Union and the
                US, which is intended to ensure compliance with European data protection standards
                for data processing in the US. Every company certified under the DPF is obliged to
                comply with these data protection standards. For more information, please contact
                the provider under the following link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/5780"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/5780
                </a>
                .
              </p>
              <h3>Google Ads Remarketing</h3>{' '}
              <p>
                This website uses the functions of Google Ads Remarketing. The provider of these
                solutions is Google Ireland Limited (&ldquo;Google&rdquo;), Gordon House, Barrow
                Street, Dublin 4, Ireland.
              </p>{' '}
              <p>
                With Google Ads Remarketing, we can assign people who interact with our online
                offering to specific target groups in order to subsequently display interest-based
                advertising to them in the Google advertising network (remarketing or retargeting).
              </p>{' '}
              <p>
                Moreover, it is possible to link the advertising target groups generated with Google
                Ads Remarketing to device encompassing functions of Google. This makes it possible
                to display interest-based customized advertising messages, depending on your prior
                usage and browsing patterns on a device (e.g., cell phone) in a manner tailored to
                you as well as on any of your devices (e.g., tablet or PC).
              </p>{' '}
              <p>
                If you have a Google account, you have the option to object to personalized
                advertising under the following link:{' '}
                <a
                  href="https://adssettings.google.com/anonymous?hl=de"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://adssettings.google.com/anonymous?hl=de
                </a>
                .
              </p>{' '}
              <p>
                The use of these services occurs on the basis of your consent pursuant to Art.
                6(1)(a) GDPR and &sect; 25(1) TDDDG. You may revoke your consent at any time.
              </p>{' '}
              <p>
                For further information and the pertinent data protection regulations, please
                consult the Data Privacy Policies of Google at:{' '}
                <a
                  href="https://policies.google.com/technologies/ads?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://policies.google.com/technologies/ads?hl=en
                </a>
                .
              </p>
              <p>
                The company is certified in accordance with the &ldquo;EU-US Data Privacy
                Framework&rdquo; (DPF). The DPF is an agreement between the European Union and the
                US, which is intended to ensure compliance with European data protection standards
                for data processing in the US. Every company certified under the DPF is obliged to
                comply with these data protection standards. For more information, please contact
                the provider under the following link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/5780"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/5780
                </a>
                .
              </p>
              <h3>Google Conversion-Tracking</h3>{' '}
              <p>
                This website uses Google Conversion Tracking. The provider of this service is Google
                Ireland Limited (&ldquo;Google&rdquo;), Gordon House, Barrow Street, Dublin 4,
                Ireland.
              </p>{' '}
              <p>
                With the assistance of Google Conversion Tracking, we are in a position to recognize
                whether the user has completed certain actions. For instance, we can analyze the how
                frequently which buttons on our website have been clicked and which products are
                reviewed or purchased with particular frequency. The purpose of this information is
                to compile conversion statistics. We learn how many users have clicked on our ads
                and which actions they have completed. We do not receive any information that would
                allow us to personally identify the users. Google as such uses cookies or comparable
                recognition technologies for identification purposes.
              </p>{' '}
              <p>
                The use of these services occurs on the basis of your consent pursuant to Art.
                6(1)(a) GDPR and &sect; 25(1) TDDDG. You may revoke your consent at any time.
              </p>{' '}
              <p>
                For more information about Google Conversion Tracking, please review Google&rsquo;s
                data protection policy at:{' '}
                <a
                  href="https://policies.google.com/privacy?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://policies.google.com/privacy?hl=en
                </a>
              </p>
              <p>
                The company is certified in accordance with the &ldquo;EU-US Data Privacy
                Framework&rdquo; (DPF). The DPF is an agreement between the European Union and the
                US, which is intended to ensure compliance with European data protection standards
                for data processing in the US. Every company certified under the DPF is obliged to
                comply with these data protection standards. For more information, please contact
                the provider under the following link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/5780"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/5780
                </a>
                .
              </p>
              <h3>LinkedIn Insight Tag</h3>{' '}
              <p>
                This website uses the Insight tag from LinkedIn. This service is provided by
                LinkedIn Ireland Unlimited Company, Wilton Plaza, Wilton Place, Dublin 2, Ireland.
              </p>{' '}
              <h4>Data processing by LinkedIn Insight tag</h4>{' '}
              <p>
                We use the LinkedIn Insight tag to obtain information about visitors to our website.
                Once a website visitor is registered with LinkedIn, we can analyze the key
                occupational data (e.g., career level, company size, country, location, industry,
                job title) of our website visitors to help us better target our site to the relevant
                audience. We can also use LinkedIn Insight tags to measure whether visitors to our
                websites make a purchase or perform other actions (conversion measurement).
                Conversion measurement can also be carried out across devices (e.g. from PC to
                tablet). LinkedIn Insight Tag also features a retargeting function that allows us to
                display targeted advertising to visitors to our website outside of the website.
                According to LinkedIn, no identification of the advertising addressee takes place.
              </p>{' '}
              <p>
                LinkedIn itself also collects log files (URL, referrer URL, IP address, device and
                browser characteristics and time of access). The IP addresses are shortened or (if
                they are used to reach LinkedIn members across devices) hashed (pseudonymized). The
                direct identifiers of LinkedIn members are deleted by LinkedIn after seven days. The
                remaining pseudonymized data will then be deleted within 180 days.
              </p>{' '}
              <p>
                The data collected by LinkedIn cannot be assigned by us as a website operator to
                specific individuals. LinkedIn will store the personal data collected from website
                visitors on its servers in the USA and use it for its own promotional activities.
                For details, please see LinkedIn&rsquo;s privacy policy at{' '}
                <a
                  href="https://www.linkedin.com/legal/privacy-policy#choices-oblig"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linkedin.com/legal/privacy-policy#choices-oblig
                </a>
                .
              </p>{' '}
              <h4>Legal basis</h4>{' '}
              <p>
                If your approval (consent) has been obtained the use of the abovementioned service
                shall occur on the basis of Art. 6(1)(a) GDPR and &sect; 25 TDDDG (German
                Telecommunications Act). Such consent may be revoked at any time. If your consent
                was not obtained, the use of the service will occur on the basis of Art. 6(1)(f)
                GDPR; the website operator has a legitimate interest in effective advertising
                promotions that include the utilization of social media.
              </p>{' '}
              <p>
                Data transmission to the US is based on the Standard Contractual Clauses (SCC) of
                the European Commission. Details can be found here:{' '}
                <a
                  href="https://www.linkedin.com/legal/l/dpa"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linkedin.com/legal/l/dpa
                </a>{' '}
                and{' '}
                <a
                  href="https://www.linkedin.com/legal/l/eu-sccs"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linkedin.com/legal/l/eu-sccs
                </a>
                .
              </p>{' '}
              <p>
                The company is certified in accordance with the &ldquo;EU-US Data Privacy
                Framework&rdquo; (DPF). The DPF is an agreement between the European Union and the
                US, which is intended to ensure compliance with European data protection standards
                for data processing in the US. Every company certified under the DPF is obliged to
                comply with these data protection standards. For more information, please contact
                the provider under the following link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/5448"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/5448
                </a>
                .
              </p>
              <h4>Objection to the use of LinkedIn Insight Tag</h4>{' '}
              <p>
                You can object to LinkedIn&rsquo;s analysis of user behavior and targeted
                advertising at the following link:{' '}
                <a
                  href="https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linkedin.com/psettings/guest-controls/retargeting-opt-out
                </a>
                .
              </p>{' '}
              <p>
                In addition, LinkedIn members can control the use of their personal information for
                promotional purposes in the account settings. To prevent LinkedIn from linking
                information collected on our site to your LinkedIn account, you must log out of your
                LinkedIn account before you visit our site.
              </p>
              <h4>Data processing</h4>{' '}
              <p>
                We have concluded a data processing agreement (DPA) for the use of the
                above-mentioned service. This is a contract mandated by data privacy laws that
                guarantees that they process personal data of our website visitors only based on our
                instructions and in compliance with the GDPR.
              </p>
              <h2>5. Newsletter</h2>
              <h3>Newsletter data</h3>{' '}
              <p>
                If you would like to receive the newsletter offered on the website, we require an
                e-mail address from you as well as information that allows us to verify that you are
                the owner of the e-mail address provided and that you agree to receive the
                newsletter. Further data is not collected or only on a voluntary basis. For the
                handling of the newsletter, we use newsletter service providers, which are described
                below.
              </p>
              <h3>Brevo</h3>{' '}
              <p>
                This website uses Brevo for the sending of newsletters. The provider is the
                Sendinblue GmbH, K&ouml;penicker Stra&szlig;e 126, 10179 Berlin, Germany.
              </p>{' '}
              <p>
                Brevo services can, among other things, be used to organize and analyze the sending
                of newsletters. The data you enter for the purpose of subscribing to the newsletter
                are archived on servers of Sendinblue GmbH in Germany.
              </p>{' '}
              <h4>Data analysis by Brevo</h4>{' '}
              <p>
                Brevo enables us to analyze our newsletter campaigns. For instance, it allows us to
                see whether a newsletter message has been opened and, if so, which links may have
                been clicked. This enables us to determine, which links drew an extraordinary number
                of clicks.
              </p>{' '}
              <p>
                Moreover, we are also able to see whether once the e-mail was opened or a link was
                clicked, any previously defined actions were taken (conversion rate). This allows us
                to determine whether you have made a purchase after clicking on the newsletter.
              </p>{' '}
              <p>
                Brevo also enables us to divide the subscribers to our newsletter into various
                categories (i.e., to &ldquo;cluster&rdquo; recipients). For instance, newsletter
                recipients can be categorized based on age, gender, or place of residence. This
                enables us to tailor our newsletter more effectively to the needs of the respective
                target groups.
              </p>{' '}
              <p>
                If you do not want to permit an analysis by Brevo, you must unsubscribe from the
                newsletter. We provide a link for you to do this in every newsletter message.
                Moreover, you can also unsubscribe from the newsletter right on the website.
              </p>{' '}
              <p>
                For detailed information on the functions of Brevo please follow this link:{' '}
                <a
                  href="https://www.brevo.com/de/newsletter-software/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.brevo.com/de/newsletter-software/
                </a>
                .
              </p>{' '}
              <h4>Legal basis</h4>{' '}
              <p>
                The data is processed based on your consent (Art. 6(1)(a) GDPR). You may revoke any
                consent you have given at any time by unsubscribing from the newsletter. This shall
                be without prejudice to the lawfulness of any data processing transactions that have
                taken place prior to your revocation.
              </p>{' '}
              <h4>Storage period</h4>{' '}
              <p>
                The data deposited with us for the purpose of subscribing to the newsletter will be
                stored by us until you unsubscribe from the newsletter or the newsletter service
                provider and deleted from the newsletter distribution list after you unsubscribe
                from the newsletter. Data stored for other purposes with us remain unaffected.
              </p>{' '}
              <p>
                After you unsubscribe from the newsletter distribution list, your e-mail address may
                be stored by us or the newsletter service provider in a blacklist, if such action is
                necessary to prevent future mailings. The data from the blacklist is used only for
                this purpose and not merged with other data. This serves both your interest and our
                interest in complying with the legal requirements when sending newsletters
                (legitimate interest within the meaning of Art. 6(1)(f) GDPR). The storage in the
                blacklist is indefinite.{' '}
                <strong>
                  You may object to the storage if your interests outweigh our legitimate interest.
                </strong>
              </p>{' '}
              <p>
                For more details, please consult the Data Protection Regulations of Brevo at:{' '}
                <a
                  href="https://www.brevo.com/de/datenschutz-uebersicht/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.brevo.com/de/datenschutz-uebersicht/
                </a>{' '}
                and{' '}
                <a
                  href="https://www.brevo.com/de/legal/privacypolicy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.brevo.com/de/legal/privacypolicy/
                </a>
                .
              </p>
              <h4>Data processing</h4>{' '}
              <p>
                We have concluded a data processing agreement (DPA) for the use of the
                above-mentioned service. This is a contract mandated by data privacy laws that
                guarantees that they process personal data of our website visitors only based on our
                instructions and in compliance with the GDPR.
              </p>
              <h3>Newsletter mailing to existing customers</h3>{' '}
              <p>
                If you order goods or services from us and enter your e-mail address, this e-mail
                address may subsequently be used by us to send you newsletters, provided we inform
                you of this in advance. In such a case, only direct advertising for our own similar
                goods or services will be sent via the newsletter. You can unsubscribe from this
                newsletter at any time. There is a corresponding link in every newsletter for this
                purpose. In this case, the legal basis for sending the newsletter is Art. 6 (1)(f)
                GDPR in conjunction with Section 7 (3) UWG.
              </p>{' '}
              <p>
                After you unsubscribe from the newsletter distribution list, we may store your email
                address in a blacklist to prevent future mailings to you. The data from the
                blacklist will only be used for this purpose and will not be merged with other data.
                This serves both your interest and our interest in complying with the legal
                requirements when sending newsletters (legitimate interest within the meaning of
                Art. 6 (1)(f) GDPR). Storage in the blacklist is not limited in time. You can object
                to the storage if your interests outweigh our legitimate interest.
              </p>
              <h2>6. Online marketing and partner programs</h2>
              <h3>Affiliate Programs on this website</h3>{' '}
              <p>
                We participate in affiliate partner programs. In conjunction with affiliate partner
                programs, ads of businesses are placed on websites or other media of other
                enterprises within the affiliate partner network. If you click on one of these
                affiliate ads, you will be transferred to the promoted offer. If you should
                subsequently engage in a certain transaction (conversion), the affiliate and, if
                applicable, the owner of the medium on which the advertisement is placed will
                receive a respective commission in exchange for the service. To be able to compute
                the commission amount, the affiliate network operator must be in a position to track
                the ad that has resulted in you seeing the offer and in you completing the
                predefined transaction. To make this possible, cookies or comparable recognition
                technologies are deployed (e.g., device fingerprinting).
              </p>{' '}
              <p>
                Data is stored and analyzed on the basis of Art. 6(1)(f) GDPR. Participants in the
                affiliate program have a legitimate interest in the correct computation of the
                affiliate compensation. If appropriate consent has been obtained, the processing is
                carried out exclusively on the basis of Art. 6(1)(a) GDPR and &sect; 25 (1) TDDDG,
                insofar the consent includes the storage of cookies or the access to information in
                the user&rsquo;s end device (e.g., device fingerprinting) within the meaning of the
                TDDDG. This consent can be revoked at any time.
              </p>
              <p>We participate in the following affiliate programs:</p>
              <p>Rakuten Advertising - www.rakutenadvertising.com</p>
              <h2>7. eCommerce and payment service providers</h2>
              <h3>Processing of Customer and Contract Data</h3>{' '}
              <p>
                We collect, process, and use personal customer and contract data for the
                establishment, content arrangement and modification of our contractual
                relationships. Data with personal references to the use of this website (usage data)
                will be collected, processed, and used only if this is necessary to enable the user
                to use our services or required for billing purposes. The legal basis for these
                processes is Art. 6(1)(b) GDPR.
              </p>{' '}
              <p>
                The collected customer data shall be deleted upon completion of the order or
                termination of the business relationship and upon expiration of any existing
                statutory archiving periods. This shall be without prejudice to any statutory
                archiving periods.
              </p>
              <h3>
                Data transfer upon closing of contracts for online stores, retailers, and the
                shipment of merchandise
              </h3>{' '}
              <p>
                Whenever you order merchandise from us, we will share your personal data with the
                transportation company entrusted with the delivery as well as the payment service
                commissioned to handle the payment transactions. Only the data these respective
                service providers require to meet their obligations will be shared. The legal basis
                for this sharing is Art. 6 (1)(b) GDPR, which permits the processing of data for the
                fulfillment of contractual or pre-contractual obligations. If you give us your
                respective consent pursuant to Art. 6 (1)(a) GDPR, we will share your email address
                with the transportation company entrusted with the delivery so that this company can
                notify you on the shipping status for your order via email. You have the option to
                revoke your consent at any time.
              </p>
              <h3>Data transfer upon closing of contracts for services and digital content</h3>{' '}
              <p>
                We share personal data with third parties only if this is necessary in conjunction
                with the handling of the contract; for instance, with the financial institution
                tasked with the processing of payments.
              </p>{' '}
              <p>
                Any further transfer of data shall not occur or shall only occur if you have
                expressly consented to the transfer. Any sharing of your data with third parties in
                the absence of your express consent, for instance for advertising purposes, shall
                not occur.
              </p>{' '}
              <p>
                The basis for the processing of data is Art. 6(1)(b) GDPR, which permits the
                processing of data for the fulfilment of a contract or for pre-contractual actions.
              </p>
              <h3>Payment services</h3>{' '}
              <p>
                We integrate payment services of third-party companies on our website. When you make
                a purchase from us, your payment data (e.g. name, payment amount, bank account
                details, credit card number) are processed by the payment service provider for the
                purpose of payment processing. For these transactions, the respective contractual
                and data protection provisions of the respective providers apply. The use of the
                payment service providers is based on Art. 6(1)(b) GDPR (contract processing) and in
                the interest of a smooth, convenient, and secure payment transaction (Art. 6(1)(f)
                GDPR). Insofar as your consent is requested for certain actions, Art. 6(1)(a) GDPR
                is the legal basis for data processing; consent may be revoked at any time for the
                future.
              </p>
              <p>
                We use the following payment services / payment service providers within the scope
                of this website:
              </p>
              <h4>PayPal</h4>{' '}
              <p>
                The provider of this payment service is PayPal (Europe) S.&agrave;.r.l. et Cie,
                S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg (hereinafter &ldquo;PayPal&rdquo;).
              </p>{' '}
              <p>
                Data transmission to the US is based on the Standard Contractual Clauses (SCC) of
                the European Commission. Details can be found here:{' '}
                <a
                  href="https://www.paypal.com/de/webapps/mpp/ua/pocpsa-full"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.paypal.com/de/webapps/mpp/ua/pocpsa-full
                </a>
                .
              </p>{' '}
              <p>
                Details can be found in PayPal&rsquo;s privacy policy:{' '}
                <a
                  href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.paypal.com/de/webapps/mpp/ua/privacy-full
                </a>
                .
              </p>
              <h4>Stripe</h4>{' '}
              <p>
                The provider for customers within the EU is Stripe Payments Europe, Ltd,1 Grand
                Canal Street Lower, Grand Canal Dock, Dublin, Ireland (hereinafter
                &ldquo;Stripe&rdquo;).
              </p>{' '}
              <p>
                Data transmission to the US is based on the Standard Contractual Clauses (SCC) of
                the European Commission. Details can be found here:{' '}
                <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">
                  https://stripe.com/de/privacy
                </a>{' '}
                and{' '}
                <a
                  href="https://stripe.com/de/guides/general-data-protection-regulation"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://stripe.com/de/guides/general-data-protection-regulation
                </a>
                .
              </p>{' '}
              <p>
                Details can be found in Stripe&rsquo;s Privacy Policy at the following link:{' '}
                <a href="https://stripe.com/de/privacy" target="_blank" rel="noopener noreferrer">
                  https://stripe.com/de/privacy
                </a>
                .
              </p>
              <h2>8. Online-based Audio and Video Conferences (Conference tools)</h2>
              <h4>Data processing</h4>{' '}
              <p>
                We use online conference tools, among other things, for communication with our
                customers. The tools we use are listed in detail below. If you communicate with us
                by video or audio conference using the Internet, your personal data will be
                collected and processed by the provider of the respective conference tool and by us.
                The conferencing tools collect all information that you provide/access to use the
                tools (email address and/or your phone number). Furthermore, the conference tools
                process the duration of the conference, start and end (time) of participation in the
                conference, number of participants and other &ldquo;context information&rdquo;
                related to the communication process (metadata).
              </p>{' '}
              <p>
                Furthermore, the provider of the tool processes all the technical data required for
                the processing of the online communication. This includes, in particular, IP
                addresses, MAC addresses, device IDs, device type, operating system type and
                version, client version, camera type, microphone or loudspeaker and the type of
                connection.
              </p>{' '}
              <p>
                Should content be exchanged, uploaded, or otherwise made available within the tool,
                it is also stored on the servers of the tool provider. Such content includes, but is
                not limited to, cloud recordings, chat/ instant messages, voicemail uploaded photos
                and videos, files, whiteboards, and other information shared while using the
                service.
              </p>{' '}
              <p>
                Please note that we do not have complete influence on the data processing procedures
                of the tools used. Our possibilities are largely determined by the corporate policy
                of the respective provider. Further information on data processing by the conference
                tools can be found in the data protection declarations of the tools used, and which
                we have listed below this text.
              </p>{' '}
              <h4>Purpose and legal bases</h4>{' '}
              <p>
                The conference tools are used to communicate with prospective or existing
                contractual partners or to offer certain services to our customers (Art. 6(1)(b)
                GDPR). Furthermore, the use of the tools serves to generally simplify and accelerate
                communication with us or our company (legitimate interest in the meaning of Art.
                6(1)(f) GDPR). Insofar as consent has been requested, the tools in question will be
                used on the basis of this consent; the consent may be revoked at any time with
                effect from that date.
              </p>{' '}
              <h4>Duration of storage</h4>{' '}
              <p>
                Data collected directly by us via the video and conference tools will be deleted
                from our systems immediately after you request us to delete it, revoke your consent
                to storage, or the reason for storing the data no longer applies. Stored cookies
                remain on your end device until you delete them. Mandatory legal retention periods
                remain unaffected.
              </p>{' '}
              <p>
                We have no influence on the duration of storage of your data that is stored by the
                operators of the conference tools for their own purposes. For details, please
                directly contact the operators of the conference tools.
              </p>{' '}
              <h4>Conference tools used</h4> <p>We employ the following conference tools:</p>
              <h3>Microsoft Teams</h3>{' '}
              <p>
                We use Microsoft Teams. The provider is the Microsoft Ireland Operations Limited,
                One Microsoft Place, South County Business Park, Leopardstown, Dublin 18, Ireland.
                For details on data processing, please refer to the Microsoft Teams privacy policy:{' '}
                <a
                  href="https://privacy.microsoft.com/en-us/privacystatement"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://privacy.microsoft.com/en-us/privacystatement
                </a>
                .
              </p>
              <p>
                The company is certified in accordance with the &ldquo;EU-US Data Privacy
                Framework&rdquo; (DPF). The DPF is an agreement between the European Union and the
                US, which is intended to ensure compliance with European data protection standards
                for data processing in the US. Every company certified under the DPF is obliged to
                comply with these data protection standards. For more information, please contact
                the provider under the following link:{' '}
                <a
                  href="https://www.dataprivacyframework.gov/participant/6474"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.dataprivacyframework.gov/participant/6474
                </a>
                .
              </p>
              <h4>Data processing</h4>{' '}
              <p>
                We have concluded a data processing agreement (DPA) for the use of the
                above-mentioned service. This is a contract mandated by data privacy laws that
                guarantees that they process personal data of our website visitors only based on our
                instructions and in compliance with the GDPR.
              </p>
            </div>
          </div>
        </DIV>
        <Footer hideCookieSettings={true} />
      </div>
    </>
  );
};

export default Privacy;
